<template>
  <div class="kpi-filter-panel">
    <!-- Assistant IA -->
    <div class="ai-assistant" style="margin-bottom: 20px;">
      <el-input
        v-model="aiQuery"
        placeholder="Décrivez les données que vous souhaitez voir (ex: 'Affiche les données pour la zone Kara depuis janvier')"
        clearable
        @keyup.enter="applyFilters"
      >
        <template #suffix>
          <el-button
            type="primary"
            :loading="aiLoading"
            icon="el-icon-search"
            :disabled="!aiQuery.trim()"
            @click="applyFilters"
          >Rechercher</el-button>
        </template>
      </el-input>
      <div v-if="aiError" class="error-message">
        {{ aiError }}
      </div>
    </div>

    <el-form
      :model="localFilters"
      label-width="140px"
      class="filter-form"
    >
      <!-- Filtre de période -->
      <el-form-item label="📅 Période">
        <el-radio-group v-model="localPeriode.type" size="small" @change="handlePeriodeChange">
          <el-radio-button label="journalier">Journalier</el-radio-button>
          <el-radio-button label="hebdo">Hebdo</el-radio-button>
          <el-radio-button label="campagne">Campagne</el-radio-button>
          <el-radio-button label="custom">Personnalisé</el-radio-button>
        </el-radio-group>
        <div
          v-if="localPeriode.type === 'journalier'"
          class="journalier-date"
          style="display: flex; align-items: center; gap: 10px; margin-top: 10px;"
        >
          <el-date-picker
            v-model="localPeriode.date_debut"
            type="date"
            placeholder="Sélectionner une date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 180px;"
            :picker-options="{
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            }"
            @change="handleDateChange"
          />
        </div>
        <div
          v-if="localPeriode.type === 'custom'"
          class="custom-dates"
          style="display: flex; align-items: center; gap: 10px; margin-top: 10px;"
        >
          <el-date-picker
            v-model="localPeriode.date_debut"
            type="date"
            placeholder="Date début"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 180px;"
            :picker-options="localPeriode.type === 'custom' ? customStartPickerOptions : null"
            @change="handleDateChange"
          />
          <el-date-picker
            v-model="localPeriode.date_fin"
            type="date"
            placeholder="Date fin"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            size="small"
            style="width: 180px;"
            @change="handleDateChange"
          />
        </div>
        <div
          v-if="periodeDisplay"
          style="margin-top: 10px; color: #606266; font-size: 14px;"
        >
          <b>Période sélectionnée :</b> {{ periodeDisplay }}
        </div>
      </el-form-item>

      <el-divider />

      <el-form-item>
        <el-row :gutter="20">
          <!-- Région
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="🌍 Région">
              <el-select
                ref="regionSelect"
                v-model="uiRegionId"
                placeholder="Choisir une région"
                filterable
                clearable
                size="small"
                style="width: 100%;"
                @change="handleRegionChange"
              >
                <el-option
                  v-for="region in regionOptions"
                  :key="`region-option-${region.id}`"
                  :label="region.nom"
                  :value="region.id"
                  :disabled="!region.is_active"
                />
              </el-select>
            </el-form-item>
          </el-col>  -->

          <!-- Zone -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="🗺️ Zone">
              <el-select
                ref="zoneSelect"
                v-model="uiZoneId"
                placeholder="Choisir une zone"
                filterable
                clearable
                size="small"
                style="width: 100%;"
                @change="handleZoneChange"
              >
                <el-option
                  v-for="zone in zoneOptions"
                  :key="`zone-option-${zone.id}`"
                  :label="zone.nom"
                  :value="zone.id"
                  :disabled="!zone.is_active"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Commune
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="🏛️ Commune">
              <el-select
                ref="communeSelect"
                v-model="uiCommuneId"
                placeholder="Choisir une commune"
                filterable
                clearable
                size="small"
                style="width: 100%;"
                @change="handleCommuneChange"
              >
                <el-option
                  v-for="commune in communeOptions"
                  :key="`commune-option-${commune.id}`"
                  :label="commune.nom"
                  :value="commune.id"
                  :disabled="!commune.is_active"
                />
              </el-select>
            </el-form-item>
          </el-col>  -->

          <!-- Village
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="🏘️ Village">
              <el-select
                ref="villageSelect"
                v-model="uiVillageId"
                placeholder="Choisir un village"
                filterable
                clearable
                size="small"
                style="width: 100%;"
                @change="handleVillageChange"
              >
                <el-option
                  v-for="village in villageOptions"
                  :key="`village-option-${village.id}`"
                  :label="village.nom"
                  :value="village.id"
                  :disabled="!village.is_active"
                />
              </el-select>
            </el-form-item>
          </el-col> -->

          <!-- CI (Contrôleur Interne) -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="👨‍💼 CI">
              <el-select
                ref="ciSelect"
                :key="`ci-select-${ciOptions.length}`"
                v-model="localFilters.ciId"
                placeholder="Choisir un CI"
                filterable
                clearable
                size="small"
                style="width: 100%;"
                @change="handleCIChange"
                @visible-change="handleCIDropdown"
              >
                <el-option
                  v-for="ci in ciOptions"
                  :key="`ci-option-${ci.id}`"
                  :label="ci.label || formatNiveauLabel(ci)"
                  :value="ci.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Unités de production (Antennes) -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="📡 Antennes">
              <el-select
                v-model="localFilters.antenneId"
                placeholder="Choisir une antenne"
                filterable
                clearable
                size="small"
                style="width: 100%;"
                @change="handleFilterChange"
              >
                <el-option
                  v-for="antenne in antenneOptions"
                  :key="antenne.id"
                  :label="formatNiveauLabel(antenne)"
                  :value="antenne.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Groupements -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="🏘️ Groupements">
              <el-select
                v-model="localFilters.groupementId"
                placeholder="Choisir un groupement"
                filterable
                clearable
                size="small"
                style="width: 100%;"
                :loading="loadingGroupements"
                @change="handleFilterChange"
              >
                <el-option
                  v-for="groupement in groupementOptions"
                  :key="groupement.id"
                  :label="formatNiveauLabel(groupement)"
                  :value="groupement.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Producteurs -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="👥 Producteurs">
              <el-select
                v-model="localFilters.producteurId"
                placeholder="Choisir un producteur"
                filterable
                clearable
                size="small"
                style="width: 100%;"
                :loading="loadingProducteurs"
                @change="handleFilterChange"
                @visible-change="handleProducteurDropdown"
              >
                <el-option
                  v-for="producteur in producteurOptions"
                  :key="producteur.id"
                  :label="formatProducteurLabel(producteur)"
                  :value="producteur.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Cultures -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="🌾 Cultures">
              <el-select
                v-model="localFilters.cultures"
                placeholder="Sélectionner les cultures"
                multiple
                collapse-tags
                filterable
                clearable
                size="small"
                style="width: 100%;"
                @change="handleFilterChange"
              >
                <el-option
                  v-for="culture in cultureOptions"
                  :key="culture.id"
                  :label="culture.nom"
                  :value="culture.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- Certification -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="✅ Certification">
              <el-select
                v-model="localFilters.certification"
                placeholder="Certification"
                clearable
                size="small"
                style="width: 100%;"
                @change="handleFilterChange"
              >
                <el-option
                  v-for="certif in certificationOptions"
                  :key="certif.value"
                  :label="certif.label"
                  :value="certif.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- Actions -->
      <el-form-item style="margin-top: 16px; margin-bottom: 0;">
        <el-button
          type="primary"
          icon="el-icon-search"
          :loading="isApplying"
          @click="applyFilters"
        >
          Appliquer les filtres
        </el-button>
        <el-button
          icon="el-icon-refresh-left"
          @click="resetFilters"
        >
          Réinitialiser
        </el-button>
      </el-form-item>
    </el-form>

    <el-divider />

    <!-- Résultat des KPIs selon les filtres appliqués -->
    <!-- Ne s'affiche que lorsque des filtres ont été effectivement appliqués côté backend -->
    <div v-if="hasAppliedFilters" class="filters-result-section">
      <h3 style="margin: 20px 0 16px 0; font-size: 18px; font-weight: 600; color: #303133;">
        📊 Statistiques (KPIs) selon les filtres appliqués
      </h3>

      <!-- Résumé textuel des filtres -->
      <div v-if="showFilterSummaryText" class="filter-summary-text" style="margin: 0 0 20px 0; padding: 16px; background-color: #f5f7fa; border-radius: 4px; border-left: 4px solid #409eff; font-size: 14px; line-height: 1.6; color: #606266;">
        <div v-if="aiSummary" style="white-space: pre-line;" v-text="formatAISummary(aiSummary)" />
        <div v-else v-html="filterSummaryText" />
      </div>
      <el-row :gutter="20" class="panel-group">
        <!-- Parcelles totales -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card" @click.stop="openKpiModal('Parcelles', displayTotalParcelles)">
            <p style="font-size: 40px;">📍</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Parcelles totales</div>
              <div class="card-panel-num">{{ formatNumber(displayTotalParcelles || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Parcelles géolocalisées -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">🗺️</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Parcelles géolocalisées </div>
              <div class="card-panel-num">{{ formatNumber(filteredKpis.totalParcellesGeolocalisees || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Producteurs -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">👥</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Producteurs</div>
              <div class="card-panel-num">{{ formatNumber(displayTotalProducteursCard || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Quantités collectées -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">📦</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Quantités collectées (t)</div>
              <div class="card-panel-num">{{ formatNumber(displayQuantiteCollecteeTonnes || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Groupements -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">🏘️</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Groupements</div>
              <div class="card-panel-num">{{ formatNumber(displayTotalGroupementsCard || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Antennes -->
        <el-col
          v-if="!localFilters.antenneId"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">📡</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Antennes</div>
              <div class="card-panel-num">{{ formatNumber(displayTotalAntennesCard || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Audits -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">🔍</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Audits</div>
              <div class="card-panel-num">{{ formatNumber(displayTotalAuditsInscrits || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Contrôles Internes Créés -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">✅</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Contrôles Internes créés</div>
              <div class="card-panel-num">{{ formatNumber(displayTotalControlesInternesInscrits || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Contrôles Internes Terminés -->
        <!-- <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">✅</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Contrôles Internes Terminés</div>
              <div class="card-panel-num">{{ formatNumber(displayTotalControlesInternesTermines || 0) }}</div>
            </div>
          </div>
        </el-col> -->

        <!-- Contrôleurs -->
        <el-col
          v-if="!localFilters.ciId"
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card" style="cursor: pointer;" @click="showControleursModal">
            <p style="font-size: 40px;">👷</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Contrôleurs</div>
              <div class="card-panel-num">{{ formatNumber(filteredKpis.totalControleurs || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Formations -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">📚</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Formations</div>
              <div class="card-panel-num">{{ formatNumber(filteredKpis.totalFormations || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Surface Certifiée -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">🌾</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Surface Certifiée (ha)</div>
              <div class="card-panel-num">{{ formatNumber(filteredKpis.surfaceCertifiee || 0) }}</div>
            </div>
          </div>
        </el-col>

        <!-- Surface Déclassée -->
        <el-col
          :xs="24"
          :sm="12"
          :md="8"
          :lg="6"
          class="card-panel-col"
        >
          <div class="info-card">
            <p style="font-size: 40px;">⚠️</p>
            <div class="info-text" style="color: rgba(0, 0, 0, 0.5); font-size: 13px;">
              <div>Surface Déclassée (ha)</div>
              <div class="card-panel-num">{{ formatNumber(filteredKpis.surfaceDeclassee || 0) }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- Modal pour afficher les détails des parcelles -->
    <el-dialog
      :title="`${selectedKpiModalTitle} - Total: ${formatNumber(selectedKpiModalValue || 0)}`"
      :visible.sync="kpiModalVisible"
      width="90%"
      class="kpi-detail-modal"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :modal="true"
      :lock-scroll="true"
      :append-to-body="true"
      @close="closeKpiModal"
    >
      <div v-if="kpiModalVisible && selectedKpiModalTitle === 'Parcelles'" class="kpi-modal-content">
        <div class="parcelles-table-container">
          <div style="margin-bottom: 16px; display: flex; align-items: center; gap: 16px; flex-wrap: wrap;">
            <el-input
              v-model="parcelleSearchQuery"
              placeholder="Rechercher par code ou producteur..."
              prefix-icon="el-icon-search"
              clearable
              style="max-width: 400px;"
            />
            <el-select
              v-model="parcelleGeolocFilter"
              placeholder="Filtre géolocalisation"
              clearable
              style="width: 220px;"
            >
              <el-option label="Tous" value="tous" />
              <el-option label="Parcelles géolocalisées" value="geoloc" />
              <el-option label="Parcelles non géolocalisées" value="non-geoloc" />
            </el-select>
            <el-select
              v-model="parcelleExportFormat"
              placeholder="Exporter"
              clearable
              style="width: 200px;"
              @change="handleExportParcelles"
            >
              <el-option label="Excel" value="excel" />
              <el-option label="PDF" value="pdf" />
            </el-select>
            <div style="margin-left: auto; display: flex; align-items: center; gap: 8px;">
              <el-button
                size="mini"
                :disabled="parcellePage <= 1"
                @click="prevParcellePage"
              >
                Précédent
              </el-button>
              <span>Page {{ parcellePage }} / {{ parcelleTotalPages }}</span>
              <el-button
                size="mini"
                :disabled="parcellePage >= parcelleTotalPages"
                @click="nextParcellePage"
              >
                Suivant
              </el-button>
            </div>
          </div>
          <el-table
            v-loading="loadingParcelles"
            :data="filteredParcellesList"
            stripe
            border
            style="width: 100%"
            :default-sort="{ prop: 'code', order: 'ascending' }"
            max-height="400"
          >
            <el-table-column prop="code" label="Code" width="120" sortable>
              <template slot-scope="scope">
                {{ scope.row.code || (scope.row.parcelle && scope.row.parcelle.code) || 'N/A' }}
              </template>
            </el-table-column>
            <el-table-column label="Producteur" min-width="180">
              <template slot-scope="scope">
                {{ scope.row.nom_producteur || formatProducteurName(scope.row.producteur || scope.row.producteur_data) }}
              </template>
            </el-table-column>
            <el-table-column label="Groupement" min-width="150">
              <template slot-scope="scope">
                {{ scope.row.groupement || scope.row.groupement_nom || 'N/A' }}
              </template>
            </el-table-column>
            <el-table-column label="Localisation" min-width="200">
              <template slot-scope="scope">
                {{ formatLocalisation(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column prop="superficie" label="Superficie (ha)" width="130" sortable>
              <template slot-scope="scope">
                {{ formatNumber(scope.row.superficie || (scope.row.parcelle && scope.row.parcelle.superficie) || 0) }}
              </template>
            </el-table-column>
            <el-table-column prop="statut" label="Statut" width="120" sortable>
              <template slot-scope="scope">
                <el-tag :type="getStatutTagType(getParcelleStatut(scope.row))" size="small">
                  {{ getParcelleStatut(scope.row) || 'N/A' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Certification" width="120">
              <template slot-scope="scope">
                <el-tag :type="getParcelleStatut(scope.row) === 'AB' ? 'success' : 'info'" size="small">
                  {{ getParcelleStatut(scope.row) === 'AB' ? 'Bio' : 'Non-bio' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="Culture" min-width="150">
              <template slot-scope="scope">
                {{ formatCultures(scope.row.produits || scope.row.cultures) }}
              </template>
            </el-table-column>
            <el-table-column label="Actions" width="180" fixed="right" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <el-button
                    v-if="isParcelleGeolocated(scope.row)"
                    type="text"
                    size="small"
                    icon="el-icon-location"
                    @click="voirCarteParcelle(scope.row)"
                  >
                    Carte
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="filteredParcellesList.length === 0 && !loadingParcelles" class="empty-state" style="text-align: center; padding: 40px;">
            <p v-if="parcelleSearchQuery">Aucune parcelle trouvée avec votre recherche.</p>
            <p v-else>Aucune parcelle trouvée avec les filtres sélectionnés.</p>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- Modal pour afficher la liste des contrôleurs -->
    <el-dialog
      :title="`Liste des contrôleurs - Total: ${formatNumber(filteredKpis.totalControleurs || 0)}`"
      :visible.sync="controleursModalVisible"
      width="80%"
      :before-close="() => controleursModalVisible = false"
      :append-to-body="true"
      custom-class="kpi-modal"
    >
      <div v-if="controleursModalVisible" class="kpi-modal-content">
        <div v-if="!controleursList || controleursList.length === 0" class="no-data">
          Aucune donnée de contrôleur disponible
        </div>
        <el-table
          v-else
          v-loading="loadingControleurs"
          :data="controleursList"
          :default-sort="{prop: 'nom', order: 'ascending'}"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="code"
            label="Code"
            width="120"
            sortable
          />
          <el-table-column
            prop="nom"
            label="Nom"
            sortable
          >
            <template slot-scope="{row}">
              {{ row.nom || 'N/A' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="prenom"
            label="Prénom"
            sortable
          >
            <template slot-scope="{row}">
              {{ row.prenom || 'N/A' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="email"
            label="Email"
          >
            <template slot-scope="{row}">
              {{ row.email || 'N/A' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="numero"
            label="Téléphone"
            width="150"
          >
            <template slot-scope="{row}">
              {{ row.numero || 'N/A' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- Modal pour afficher la carte de la parcelle -->
    <el-dialog
      :key="`carte-modal-${carteModalKey}`"
      title="Carte de la parcelle"
      :visible="carteModalVisible"
      width="100%"
      top="0"
      class="carte-parcelle-modal fullscreen-modal"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :modal="true"
      :lock-scroll="true"
      :append-to-body="true"
      @close="closeCarteModal"
    >
      <div v-if="carteModalVisible" class="carte-modal-content">
        <div v-if="loadingCoordonnees" class="loading-coordonnees">
          <p>Chargement des coordonnées...</p>
        </div>
        <div v-else-if="coordonneesParcelle.length > 0" id="carte-parcelle-container" class="carte-fullscreen-container">
          <div id="carteParcelleContainer" class="carte-fullscreen-map" />
          <div v-if="selectedParcelleForCarte" class="carte-info-floating">
            <p><strong style="text-decoration: underline;">Code:</strong> {{ selectedParcelleForCarte.code || (selectedParcelleForCarte.parcelle && selectedParcelleForCarte.parcelle.code) || 'N/A' }}</p>
            <p><strong style="text-decoration: underline;">Producteur:</strong> {{ formatProducteurName(selectedParcelleForCarte.producteur || selectedParcelleForCarte.producteur_data) }}</p>
            <p><strong style="text-decoration: underline;">Groupement:</strong> {{ selectedParcelleForCarte.groupement || selectedParcelleForCarte.groupement_nom || 'N/A' }}</p>
            <p><strong style="text-decoration: underline;">Localisation:</strong> {{ formatLocalisation(selectedParcelleForCarte) }}</p>
            <p><strong style="text-decoration: underline;">Superficie:</strong> {{ formatNumber(selectedParcelleForCarte.superficie || (selectedParcelleForCarte.parcelle && selectedParcelleForCarte.parcelle.superficie) || 0) }} ha</p>
            <p><strong style="text-decoration: underline;">Statut:</strong> {{ getParcelleStatut(selectedParcelleForCarte) || 'N/A' }}</p>
            <p><strong style="text-decoration: underline;">Certification:</strong> {{ getParcelleStatut(selectedParcelleForCarte) === 'AB' ? 'Bio' : 'Non-bio' }}</p>
            <p><strong style="text-decoration: underline;">Culture:</strong> {{ formatCultures(selectedParcelleForCarte.produits || selectedParcelleForCarte.cultures) }}</p>
          </div>
          <button id="zoomto-parcelle" class="btn-control-carte">Voir la parcelle</button>
        </div>
        <div v-else class="no-coordonnees">
          <el-tag type="info">Cette parcelle n'a pas de coordonnées GPS</el-tag>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeCarteModal">Fermer</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Resource from '@/api/resource';
import DashboardAPI from '@/api/dashboard';
import mapboxgl from 'mapbox-gl';
import { export_json_to_excel } from '@/vendor/Export2Excel';
import jsPDF from 'jspdf';

const regionResource = new Resource('regions');
const zoneResource = new Resource('zones');
const communeResource = new Resource('communes');
const villageResource = new Resource('villages');

export default {
  name: 'KpiFilterPanel',
  props: {
    kpis: {
      type: Object,
      default: () => ({}),
    },
    controleurs: {
      type: Array,
      default: () => [],
    },
    parcelles: {
      type: Array,
      default: () => [],
    },
    parcellesProducteurs: {
      type: Array,
      default: () => [],
    },
    producteurs: {
      type: Array,
      default: () => [],
    },
    groupements: {
      type: Array,
      default: () => [],
    },
    unitesProductions: {
      type: Array,
      default: () => [],
    },
    audits: {
      type: Array,
      default: () => [],
    },
    controlesInternes: {
      type: Array,
      default: () => [],
    },
    dataQuantiteCollectee: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // Propriétés pour l'assistant IA
      aiQuery: '',
      aiLoading: false,
      aiError: null,
      aiSummary: null,
      showFilterSummaryText: false,
      localPeriode: {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      },
      // UI uniquement: permet d'afficher la région sélectionnée sans déclencher
      // le traitement des filtres (car localFilters.regionId est utilisé par des computed coûteux).
      uiRegionId: null,
      uiZoneId: null,
      uiCommuneId: null,
      uiVillageId: null,
      localFilters: {
        regionId: null,
        ciId: null,
        antenneId: null,
        groupementId: null,
        producteurId: null,
        cultures: [],
        certification: 'toutes',
      },
      loadingProducteurs: false,
      loadingGroupements: false,
      isApplying: false,
      producteurOptionsLocal: [],
      ciOptionsList: [], // Stocker les options CI localement pour assurer la réactivité
      regions: [], // Liste des régions
      zones: [], // Liste des zones
      communes: [], // Liste des communes
      villages: [], // Liste des villages
      filteredKpis: {
        totalParcelles: 0,
        totalParcellesGeolocalisees: 0,
        totalProducteurs: 0,
        totalControleurs: 0,
        totalGroupements: 0,
        totalAntennes: 0,
        totalAudits: 0,
        totalControlesInternes: 0,
        totalFormations: 0,
        surfaceCertifiee: 0,
        surfaceDeclassee: 0,
        totalQuantiteCollectee: 0,
      },
      // showFilterSummaryText est déjà défini plus haut, on le supprime ici
      suppressFilterSummaryText: false,
      hasAppliedFilters: false, // Indique si des filtres ont déjà été appliqués côté backend
      customStartPickerOptions: {
        // Empêcher la sélection d'une date de début supérieure à la date du jour en mode personnalisé
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() > today.getTime();
        },
      },
      // Propriétés pour la modale des parcelles
      kpiModalVisible: false,
      selectedKpiModalTitle: '',
      selectedKpiModalValue: 0,
      parcelleSearchQuery: '',
      parcelleGeolocFilter: 'tous',
      parcelleExportFormat: null,
      parcellePage: 1,
      parcellePageSize: 20,
      loadingParcelles: false,
      parcellesList: [],
      selectedParcelleForCarte: null,
      carteModalVisible: false,
      controleursModalVisible: false,
      carteModalKey: 0,
      coordonneesParcelle: [],
      loadingCoordonnees: false,
      mapInstance: null,
      mapboxAccessToken: 'pk.eyJ1IjoiZGV2b25lc295IiwiYSI6ImNsMTR0c2Y0MDBkdWIzZHF6cjk5OWJ1NnMifQ.cEu2E93WCC2rY74DEjqixg',
      // Pour la modale controleur
      controleursList: [],
    };
  },
  computed: {
    ...mapGetters('dashboard', ['filters', 'activeFilters', 'filterOptions']),
    selectedRegionId() {
      // Région effectivement "sélectionnée" côté UI.
      // On privilégie uiRegionId pour éviter de déclencher les traitements liés à localFilters.regionId.
      return this.uiRegionId != null ? this.uiRegionId : this.localFilters.regionId;
    },
    selectedZoneId() {
      return this.uiZoneId != null ? this.uiZoneId : null;
    },
    selectedCommuneId() {
      return this.uiCommuneId != null ? this.uiCommuneId : null;
    },
    selectedVillageId() {
      return this.uiVillageId != null ? this.uiVillageId : null;
    },
    ciOptions() {
      // Retourner directement les options stockées localement pour garantir la réactivité
      return this.ciOptionsList;
    },
    // Comptages filtrés côté frontend pour CI (sans dépendre des KPIs en props)
    ciGroupements() {
      if (!this.localFilters.ciId || !Array.isArray(this.groupements) || this.groupements.length === 0) {
        return [];
      }
      const ciId = Number(this.localFilters.ciId);
      if (isNaN(ciId)) {
        return [];
      }
      try {
        return this.groupements.filter(g => g && g.controleur_id != null && Number(g.controleur_id) === ciId);
      } catch (error) {
        console.error('Erreur dans ciGroupements:', error);
        return [];
      }
    },
    ciGroupementsCount() {
      return this.ciGroupements.length;
    },
    ciAntenneIds() {
      const ids = new Set();
      try {
        if (!Array.isArray(this.ciGroupements) || this.ciGroupements.length === 0) {
          return ids;
        }
        this.ciGroupements.forEach(g => {
          if (g && g.unite_production_id != null) {
            const upId = Number(g.unite_production_id);
            if (!isNaN(upId)) {
              ids.add(upId);
            }
          }
        });
      } catch (error) {
        console.error('Erreur dans ciAntenneIds:', error);
      }
      return ids;
    },
    ciAntennesCount() {
      return this.ciAntenneIds.size;
    },
    ciParcellesIds() {
      // Parcelles liées aux producteurs des groupements du CI
      if (!this.localFilters.ciId || !Array.isArray(this.groupements) || this.groupements.length === 0 || !Array.isArray(this.parcellesProducteurs) || this.parcellesProducteurs.length === 0) {
        return new Set();
      }
      const ciId = Number(this.localFilters.ciId);
      if (isNaN(ciId)) {
        return new Set();
      }
      try {
        const groupementIds = new Set(
          this.groupements
            .filter(g => g && g.controleur_id != null && Number(g.controleur_id) === ciId && g.id != null)
            .map(g => Number(g.id))
            .filter(id => !isNaN(id))
        );
        if (groupementIds.size === 0) {
          return new Set();
        }

        // Obtenir l'ID de la campagne en cours
        const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];

        const parcelleIds = new Set();
        this.parcellesProducteurs.forEach(pp => {
          if (!pp || pp.parcelle_id == null || pp.producteur_id == null) {
            return;
          }
          // Filtrer par campagne si cmp_id est disponible
          if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
            return;
          }

          // Utiliser groupement_id directement depuis parcellesProducteurs (ajouté par le backend)
          // Cela permet de compter les parcelles même si le producteur est inactif/invisible
          if (pp.groupement_id != null && groupementIds.has(Number(pp.groupement_id))) {
            parcelleIds.add(Number(pp.parcelle_id));
          }
        });
        return parcelleIds;
      } catch (error) {
        console.error('Erreur dans ciParcellesIds:', error);
        return new Set();
      }
    },
    ciParcellesCount() {
      return this.ciParcellesIds.size;
    },
    regionParcellesIds() {
      // Parcelles d'une région basées sur parcellesProducteurs (pp.region_id) — même logique que ciParcellesIds
      const regionId = this.selectedRegionId;
      if (regionId == null || !Array.isArray(this.parcellesProducteurs)) {
        return new Set();
      }

      const regionIdNum = Number(regionId);
      if (Number.isNaN(regionIdNum)) {
        return new Set();
      }

      const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
      const parcelleIds = new Set();

      this.parcellesProducteurs.forEach(pp => {
        if (!pp || pp.parcelle_id == null) {
          return;
        }
        // Filtrer par campagne si cmp_id est disponible
        if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
          return;
        }
        if (pp.region_id != null && Number(pp.region_id) === regionIdNum) {
          parcelleIds.add(Number(pp.parcelle_id));
        }
      });

      return parcelleIds;
    },
    regionParcellesCount() {
      // Si la période est "campagne", retourner le total sans filtre de date
      if (!this.localPeriode || !this.localPeriode.type || this.localPeriode.type === 'campagne') {
        return this.regionParcellesIds.size;
      }
      // Sinon, appliquer le filtre de période (created_at)
      const periodeRange = this.getPeriodeDateRange();
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return this.regionParcellesIds.size;
      }
      // Créer un index de parcelle_producteur.created_at par parcelle_id
      const createdAtByParcelleId = {};
      if (Array.isArray(this.parcellesProducteurs) && this.parcellesProducteurs.length > 0) {
        this.parcellesProducteurs.forEach(pp => {
          if (pp && pp.parcelle_id != null && pp.created_at && this.regionParcellesIds.has(Number(pp.parcelle_id))) {
            createdAtByParcelleId[Number(pp.parcelle_id)] = pp.created_at;
          }
        });
      }
      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };
      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };
      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);
      let count = 0;
      this.regionParcellesIds.forEach(parcelleId => {
        const createdAt = createdAtByParcelleId[parcelleId];
        if (!createdAt) {
          return;
        }
        const parcelleDate = new Date(createdAt);
        if (Number.isNaN(parcelleDate.getTime())) {
          return;
        }
        if (startDate && parcelleDate < startDate) {
          return;
        }
        if (endDate && parcelleDate > endDate) {
          return;
        }
        count++;
      });
      return count;
    },
    zoneParcellesIds() {
      // Parcelles d'une zone basées sur parcellesProducteurs (pp.zone_id)
      const zoneId = this.selectedZoneId;
      if (zoneId == null || !Array.isArray(this.parcellesProducteurs)) {
        return new Set();
      }
      const zoneIdNum = Number(zoneId);
      if (Number.isNaN(zoneIdNum)) {
        return new Set();
      }
      const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
      const parcelleIds = new Set();
      this.parcellesProducteurs.forEach(pp => {
        if (!pp || pp.parcelle_id == null) {
          return;
        }
        if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
          return;
        }
        if (pp.zone_id != null && Number(pp.zone_id) === zoneIdNum) {
          parcelleIds.add(Number(pp.parcelle_id));
        }
      });
      return parcelleIds;
    },
    zoneParcellesCount() {
      return this.zoneParcellesIds.size;
    },
    communeParcellesIds() {
      // Parcelles d'une commune basées sur parcellesProducteurs (pp.commune_id)
      const communeId = this.selectedCommuneId;
      if (communeId == null || !Array.isArray(this.parcellesProducteurs)) {
        return new Set();
      }
      const communeIdNum = Number(communeId);
      if (Number.isNaN(communeIdNum)) {
        return new Set();
      }
      const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
      const parcelleIds = new Set();
      this.parcellesProducteurs.forEach(pp => {
        if (!pp || pp.parcelle_id == null) {
          return;
        }
        if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
          return;
        }
        if (pp.commune_id != null && Number(pp.commune_id) === communeIdNum) {
          parcelleIds.add(Number(pp.parcelle_id));
        }
      });
      return parcelleIds;
    },
    communeParcellesCount() {
      return this.communeParcellesIds.size;
    },
    villageParcellesIds() {
      // Parcelles d'un village basées sur parcellesProducteurs (pp.village_id)
      const villageId = this.selectedVillageId;
      if (villageId == null || !Array.isArray(this.parcellesProducteurs)) {
        return new Set();
      }
      const villageIdNum = Number(villageId);
      if (Number.isNaN(villageIdNum)) {
        return new Set();
      }
      const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
      const parcelleIds = new Set();
      this.parcellesProducteurs.forEach(pp => {
        if (!pp || pp.parcelle_id == null) {
          return;
        }
        if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
          return;
        }
        if (pp.village_id != null && Number(pp.village_id) === villageIdNum) {
          parcelleIds.add(Number(pp.parcelle_id));
        }
      });
      return parcelleIds;
    },
    villageParcellesCount() {
      return this.villageParcellesIds.size;
    },
    regionProducteurIds() {
      // Producteurs uniques de la région (campagne en cours), basé sur parcellesProducteurs (pp.region_id)
      const regionId = this.selectedRegionId;
      if (regionId == null || !Array.isArray(this.parcellesProducteurs)) {
        return new Set();
      }
      const regionIdNum = Number(regionId);
      if (Number.isNaN(regionIdNum)) {
        return new Set();
      }
      const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
      const ids = new Set();
      this.parcellesProducteurs.forEach(pp => {
        if (!pp || pp.producteur_id == null) {
          return;
        }
        if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
          return;
        }
        if (pp.region_id != null && Number(pp.region_id) === regionIdNum) {
          ids.add(Number(pp.producteur_id));
        }
      });
      return ids;
    },
    regionProducteursCount() {
      // Si la période est "campagne", retourner le total sans filtre de date
      if (!this.localPeriode || !this.localPeriode.type || this.localPeriode.type === 'campagne') {
        return this.regionProducteurIds.size;
      }
      // Sinon, appliquer le filtre de période (created_at)
      const periodeRange = this.getPeriodeDateRange();
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return this.regionProducteurIds.size;
      }
      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };
      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };
      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);
      let count = 0;
      if (Array.isArray(this.producteurs) && this.producteurs.length > 0) {
        this.producteurs.forEach(p => {
          if (!p || p.id == null || !this.regionProducteurIds.has(Number(p.id))) {
            return;
          }
          const createdAt = p.created_at;
          if (!createdAt) {
            return;
          }
          const prodDate = new Date(createdAt);
          if (Number.isNaN(prodDate.getTime())) {
            return;
          }
          if (startDate && prodDate < startDate) {
            return;
          }
          if (endDate && prodDate > endDate) {
            return;
          }
          count++;
        });
      }
      return count;
    },
    regionGroupementIds() {
      // Groupements uniques de la région via producteurs -> groupement_id
      if (!Array.isArray(this.producteurs) || this.producteurs.length === 0) {
        return new Set();
      }
      const ids = new Set();
      const prodIds = this.regionProducteurIds;
      this.producteurs.forEach(p => {
        if (!p || p.id == null || p.groupement_id == null) {
          return;
        }
        if (prodIds.has(Number(p.id))) {
          ids.add(Number(p.groupement_id));
        }
      });
      return ids;
    },
    regionGroupementsCount() {
      // Si la période est "campagne", retourner le total sans filtre de date
      if (!this.localPeriode || !this.localPeriode.type || this.localPeriode.type === 'campagne') {
        return this.regionGroupementIds.size;
      }
      // Sinon, appliquer le filtre de période (created_at)
      const periodeRange = this.getPeriodeDateRange();
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return this.regionGroupementIds.size;
      }
      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };
      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };
      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);
      let count = 0;
      if (Array.isArray(this.groupements) && this.groupements.length > 0) {
        this.groupements.forEach(g => {
          if (!g || g.id == null || !this.regionGroupementIds.has(Number(g.id))) {
            return;
          }
          const createdAt = g.created_at;
          if (!createdAt) {
            return;
          }
          const grpDate = new Date(createdAt);
          if (Number.isNaN(grpDate.getTime())) {
            return;
          }
          if (startDate && grpDate < startDate) {
            return;
          }
          if (endDate && grpDate > endDate) {
            return;
          }
          count++;
        });
      }
      return count;
    },
    regionAntenneIds() {
      // Antennes uniques de la région via groupements -> unite_production_id
      if (!Array.isArray(this.groupements) || this.groupements.length === 0) {
        return new Set();
      }
      const ids = new Set();
      const grpIds = this.regionGroupementIds;
      this.groupements.forEach(g => {
        if (!g || g.id == null || g.unite_production_id == null) {
          return;
        }
        if (grpIds.has(Number(g.id))) {
          ids.add(Number(g.unite_production_id));
        }
      });
      return ids;
    },
    regionAntennesCount() {
      // Si la période est "campagne", retourner le total sans filtre de date
      if (!this.localPeriode || !this.localPeriode.type || this.localPeriode.type === 'campagne') {
        return this.regionAntenneIds.size;
      }
      // Sinon, appliquer le filtre de période (created_at) via les groupements
      const periodeRange = this.getPeriodeDateRange();
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return this.regionAntenneIds.size;
      }
      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };
      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };
      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);
      // Compter les antennes via les groupements créés dans la période
      const antennesCreated = new Set();
      if (Array.isArray(this.groupements) && this.groupements.length > 0) {
        this.groupements.forEach(g => {
          if (!g || g.id == null || g.unite_production_id == null || !this.regionGroupementIds.has(Number(g.id))) {
            return;
          }
          const createdAt = g.created_at;
          if (!createdAt) {
            return;
          }
          const grpDate = new Date(createdAt);
          if (Number.isNaN(grpDate.getTime())) {
            return;
          }
          if (startDate && grpDate < startDate) {
            return;
          }
          if (endDate && grpDate > endDate) {
            return;
          }
          // Si le groupement est créé dans la période, ajouter son antenne
          antennesCreated.add(Number(g.unite_production_id));
        });
      }
      return antennesCreated.size;
    },
    regionQuantiteCollecteeKg() {
      if (!this.selectedRegionId) {
        return 0;
      }
      const periodeRange = this.getPeriodeDateRange();
      return this.calculerQuantiteCollecteeLocaleParcelles(this.regionParcellesIds, periodeRange);
    },
    displayQuantiteCollecteeTonnes() {
      const totalQuantiteCollecteeBackend = this.filteredKpis.totalQuantiteCollectee || 0;
      return totalQuantiteCollecteeBackend;
    },
    displayTotalProducteursCard() {
      const totalProducteursBackend = this.filteredKpis.totalProducteurs || 0;
      return totalProducteursBackend;
    },
    displayTotalGroupementsCard() {
      const totalTotalGroupementsBackend = this.filteredKpis.totalGroupements || 0;
      return totalTotalGroupementsBackend;
    },
    displayTotalAntennesCard() {
      const totalTotalAntennesBackend = this.filteredKpis.totalAntennes || 0;
      return totalTotalAntennesBackend;
    },
    // Valeurs à afficher : priorité aux comptages filtrés CI, fallback KPIs reçus
    displayTotalParcelles() {
      const totalParcellesBackend = this.filteredKpis.totalParcelles || 0;
      return totalParcellesBackend;
    },
    displayTotalGroupements() {
      return this.filteredKpis.totalGroupements || 0;
    },
    displayTotalGroupementsInscrits() {
      // Si aucune période spécifique n'est sélectionnée, garder le comportement actuel
      const periodeRange = this.getPeriodeDateRange();
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return this.displayTotalGroupements;
      }

      if (!Array.isArray(this.groupements) || this.groupements.length === 0) {
        return 0;
      }

      let groupementsFiltres = this.groupements.slice();

      // Filtre par groupementId explicite
      if (this.localFilters.groupementId) {
        const groupementIdNum = Number(this.localFilters.groupementId);
        groupementsFiltres = groupementsFiltres.filter(
          (g) => g && Number(g.id) === groupementIdNum
        );
      }

      // Filtre par antenne (unite_production_id)
      if (this.localFilters.antenneId) {
        const antenneIdNum = Number(this.localFilters.antenneId);
        groupementsFiltres = groupementsFiltres.filter(
          (g) => g && g.unite_production_id != null && Number(g.unite_production_id) === antenneIdNum
        );
      }

      // Filtre par CI (controleur_id)
      if (this.localFilters.ciId) {
        const ciIdNum = Number(this.localFilters.ciId);
        groupementsFiltres = groupementsFiltres.filter(
          (g) => g && g.controleur_id != null && Number(g.controleur_id) === ciIdNum
        );
      }

      // Appliquer le filtre de période sur created_at des groupements
      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };

      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };

      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);

      // Filtrer par created_at: inclure les items créés exactement à la date de début ou de fin
      // startDate est normalisé à 00:00:00.000, endDate à 23:59:59.999
      // Les comparaisons < et > excluent uniquement les items avant/après, incluant ceux créés exactement à la date
      const groupementsFiltresParDate = groupementsFiltres.filter((g) => {
        const createdAt = g && g.created_at;
        if (!createdAt) {
          return false;
        }
        const grpDate = new Date(createdAt);
        if (Number.isNaN(grpDate.getTime())) {
          return false;
        }
        if (startDate && grpDate < startDate) {
          return false;
        }
        if (endDate && grpDate > endDate) {
          return false;
        }
        return true;
      });

      return groupementsFiltresParDate.length;
    },
    displayTotalAntennes() {
      if (this.localFilters.ciId && this.ciAntennesCount > 0) {
        return this.ciAntennesCount;
      }
      return this.filteredKpis.totalAntennes || 0;
    },
    displayTotalAntennesInscrites() {
      // Si aucune période spécifique n'est sélectionnée, garder le comportement actuel
      const periodeRange = this.getPeriodeDateRange();
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return this.displayTotalAntennes;
      }

      if (!Array.isArray(this.unitesProductions) || this.unitesProductions.length === 0) {
        return 0;
      }

      let antennesFiltres = this.unitesProductions.slice();

      // Filtre explicite par antenne sélectionnée
      if (this.localFilters.antenneId) {
        const antenneIdNum = Number(this.localFilters.antenneId);
        antennesFiltres = antennesFiltres.filter(
          up => up && Number(up.id) === antenneIdNum
        );
      }

      // Filtre par CI via les groupements (utiliser les IDs d'antennes valides pour ce CI)
      if (this.localFilters.ciId && this.ciAntenneIds && this.ciAntenneIds.size > 0) {
        antennesFiltres = antennesFiltres.filter(
          up => up && this.ciAntenneIds.has(Number(up.id))
        );
      }

      // Filtre par groupement sélectionné : ne garder que l'antenne liée à ce groupement
      if (this.localFilters.groupementId && Array.isArray(this.groupements) && this.groupements.length > 0) {
        const groupementIdNum = Number(this.localFilters.groupementId);
        const grp = this.groupements.find(g => g && Number(g.id) === groupementIdNum);
        const antenneIdFromGrp = grp && grp.unite_production_id != null ? Number(grp.unite_production_id) : null;
        if (antenneIdFromGrp != null) {
          antennesFiltres = antennesFiltres.filter(
            up => up && Number(up.id) === antenneIdFromGrp
          );
        } else {
          antennesFiltres = [];
        }
      }

      // Appliquer le filtre de période sur created_at des antennes
      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };

      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };

      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);

      const antennesFiltresParDate = antennesFiltres.filter((up) => {
        const createdAt = up && up.created_at;
        if (!createdAt) {
          return false;
        }
        const upDate = new Date(createdAt);
        if (Number.isNaN(upDate.getTime())) {
          return false;
        }
        if (startDate && upDate < startDate) {
          return false;
        }
        if (endDate && upDate > endDate) {
          return false;
        }
        return true;
      });

      return antennesFiltresParDate.length;
    },
    displayTotalProducteursInscrits() {
      // Si aucune période spécifique n'est sélectionnée, garder le comportement actuel
      const periodeRange = this.getPeriodeDateRange();
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return this.filteredKpis.totalProducteurs || 0;
      }

      if (!Array.isArray(this.producteurs) || this.producteurs.length === 0) {
        return 0;
      }

      // Index des groupements pour filtrer par CI / antenne
      const groupementById = {};
      if (Array.isArray(this.groupements)) {
        this.groupements.forEach((g) => {
          if (g && g.id != null) {
            groupementById[Number(g.id)] = g;
          }
        });
      }

      let producteursFiltres = this.producteurs.slice();

      // Filtre par producteurId explicite
      if (this.localFilters.producteurId) {
        const prodId = Number(this.localFilters.producteurId);
        producteursFiltres = producteursFiltres.filter(
          (p) => p && Number(p.id) === prodId
        );
      }

      // Filtre par groupementId
      if (this.localFilters.groupementId) {
        const groupementIdNum = Number(this.localFilters.groupementId);
        producteursFiltres = producteursFiltres.filter(
          (p) => p && Number(p.groupement_id) === groupementIdNum
        );
      }

      // Filtre par antenne (unite_production_id) via le groupement
      if (this.localFilters.antenneId) {
        const antenneIdNum = Number(this.localFilters.antenneId);
        producteursFiltres = producteursFiltres.filter((p) => {
          if (!p || p.groupement_id == null) {
            return false;
          }
          const grp = groupementById[Number(p.groupement_id)];
          return grp && grp.unite_production_id != null && Number(grp.unite_production_id) === antenneIdNum;
        });
      }

      // Filtre par CI via le groupement
      if (this.localFilters.ciId) {
        const ciIdNum = Number(this.localFilters.ciId);
        producteursFiltres = producteursFiltres.filter((p) => {
          if (!p || p.groupement_id == null) {
            return false;
          }
          const grp = groupementById[Number(p.groupement_id)];
          return grp && grp.controleur_id != null && Number(grp.controleur_id) === ciIdNum;
        });
      }

      // Appliquer le filtre de période sur created_at des producteurs
      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };

      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };

      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);

      const producteursFiltresParDate = producteursFiltres.filter((p) => {
        const createdAt = p && p.created_at;
        if (!createdAt) {
          return false;
        }
        const prodDate = new Date(createdAt);
        if (Number.isNaN(prodDate.getTime())) {
          return false;
        }
        if (startDate && prodDate < startDate) {
          return false;
        }
        if (endDate && prodDate > endDate) {
          return false;
        }
        return true;
      });

      return producteursFiltresParDate.length;
    },
    displayTotalAuditsInscrits() {
      const totalTotalAuditsInscritsBackend = this.filteredKpis.totalAudits || 0;
      return totalTotalAuditsInscritsBackend;
    },
    displayTotalControlesInternesInscrits() {
      // Toujours utiliser les données du backend comme source de vérité
      // Le backend calcule déjà les contrôles internes filtrés par campagne et autres filtres
      return this.filteredKpis.totalControlesInternes || 0;
    },
    displayTotalControlesInternesTermines() {
      if (!Array.isArray(this.controlesInternes) || this.controlesInternes.length === 0) {
        return 0;
      }

      // Filtrer par campagne_agricole_id pour s'assurer qu'on ne compte que ceux de la campagne en cours
      const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
      let controlesInternesFiltres = this.controlesInternes;
      if (campId) {
        controlesInternesFiltres = controlesInternesFiltres.filter((ci) => {
          return ci && ci.campagne_agricole_id && Number(ci.campagne_agricole_id) === Number(campId);
        });
      }

      // Filtrer les contrôles internes où date_cont != null (terminés)
      const controlesInternesTermines = controlesInternesFiltres.filter((ci) => {
        return ci && ci.date_cont != null;
      });

      return controlesInternesTermines.length;
    },
    // Quantité collectée – on s'aligne strictement sur le backend
    // Backend: getQuantiteCollectee somme les poids en kg (sacs.poids) puis divise par 1000 -> retourne des TONNES.
    // Donc:
    // - filteredKpis.totalQuantiteCollectee et kpis.quantite_collectee sont déjà en tonnes.
    // - On ne refait PAS une division côté frontend, on ne fait qu'une éventuelle conversion pour affichage en kg.
    quantiteCollecteeTonnes() {
      // Priorité absolue : KPI calculé côté backend (source de vérité)
      if (
        this.filteredKpis &&
        typeof this.filteredKpis.totalQuantiteCollectee === 'number' &&
        !Number.isNaN(this.filteredKpis.totalQuantiteCollectee)
      ) {
        return this.filteredKpis.totalQuantiteCollectee;
      }

      // Fallback éventuel sur les anciens payloads de quantités (campagne globale)
      const payload = (this.dataQuantiteCollectee && this.dataQuantiteCollectee.data_quantite_collectee)
        ? this.dataQuantiteCollectee
        : (this.dataQuantiteCollectee &&
            this.dataQuantiteCollectee.data &&
            this.dataQuantiteCollectee.data.data_quantite_collectee)
          ? this.dataQuantiteCollectee.data
          : null;

      if (payload && typeof payload.quantite_collectee === 'number') {
        // Interpréter quantite_collectee des anciens payloads comme TONNES pour rester cohérent
        return payload.quantite_collectee;
      }
      if (payload && typeof payload.quantite_collectee_kilogrammes === 'number') {
        // Ancien champ explicitement en kg
        return payload.quantite_collectee_kilogrammes / 1000;
      }
      if (payload && typeof payload.quantite_collectee_grammes === 'number') {
        // Cas extrême en grammes (1 000 000 g = 1 tonne)
        return payload.quantite_collectee_grammes / 1000000;
      }

      return 0;
    },
    quantiteCollecteeKg() {
      // Conversion simple depuis les tonnes backend -> kg, uniquement pour l'affichage textuel
      return this.quantiteCollecteeTonnes * 1000;
    },
    antenneOptions() {
      // Filtrer les antennes selon le CI sélectionné
      let options = this.filterOptions?.niveaux?.antenne?.options || [];
      if (this.localFilters.ciId) {
        const validAntenneIds = this.getValidAntenneIdsForCI(this.localFilters.ciId);
        options = options.filter(opt => validAntenneIds.includes(opt.id));
      }
      return options;
    },
    groupementOptions() {
      // Filtrer les groupements selon le CI et/ou l'antenne sélectionnés
      let options = this.filterOptions?.niveaux?.groupement?.options || [];
      if (this.localFilters.ciId) {
        const validGroupementIds = this.getValidGroupementIdsForCI(this.localFilters.ciId);
        options = options.filter(opt => validGroupementIds.includes(opt.id));
      }
      if (this.localFilters.antenneId) {
        options = options.filter(opt => opt.unite_production_id === this.localFilters.antenneId);
      }
      return options;
    },
    producteurOptions() {
      // Utiliser les producteurs chargés localement s'ils existent, sinon utiliser ceux du store
      if (this.producteurOptionsLocal.length > 0) {
        return this.producteurOptionsLocal;
      }
      return this.filterOptions?.niveaux?.producteur?.options || this.filterOptions?.producteurs || [];
    },
    cultureOptions() {
      return this.filterOptions?.cultures || [];
    },
    certificationOptions() {
      return [
        { label: 'Toutes', value: 'toutes' },
        { label: 'Bio', value: 'bio' },
        { label: 'Non bio', value: 'non_bio' },
      ];
    },
    regionOptions() {
      return this.regions || [];
    },
    zoneOptions() {
      // Lister toutes les zones par défaut, ou filtrer par région si une région est sélectionnée
      let options = this.zones || [];
      // Utiliser directement uiRegionId pour éviter les problèmes de réactivité
      const regionId = this.uiRegionId;
      // Si regionId est null, undefined, ou chaîne vide, retourner toutes les zones
      if (regionId != null && regionId !== '' && regionId !== undefined) {
        const regionIdNum = Number(regionId);
        if (!isNaN(regionIdNum)) {
          options = options.filter(zone => zone.region_id != null && Number(zone.region_id) === regionIdNum);
        }
      }
      return options;
    },
    communeOptions() {
      // Filtrer les communes selon la zone sélectionnée
      let options = this.communes || [];
      const zoneId = this.selectedZoneId;
      if (zoneId != null) {
        const zoneIdNum = Number(zoneId);
        options = options.filter(commune => commune.zone_id != null && Number(commune.zone_id) === zoneIdNum);
      }
      return options;
    },
    villageOptions() {
      // Filtrer les villages selon la commune sélectionnée
      let options = this.villages || [];
      const communeId = this.selectedCommuneId;
      if (communeId != null) {
        const communeIdNum = Number(communeId);
        options = options.filter(village => village.commune_id != null && Number(village.commune_id) === communeIdNum);
      }
      return options;
    },
    hasActiveFilters() {
      return !!(
        // Période (inclure "campagne" comme filtre actif)
        this.localPeriode.type ||
        // Niveaux hiérarchiques géographiques
        this.selectedRegionId ||
        this.selectedZoneId ||
        this.selectedCommuneId ||
        this.selectedVillageId ||
        // Niveaux hiérarchiques organisationnels
        this.localFilters.ciId ||
        this.localFilters.antenneId ||
        this.localFilters.groupementId ||
        this.localFilters.producteurId ||
        // Cultures / certification
        (this.localFilters.cultures && this.localFilters.cultures.length > 0) ||
        (this.localFilters.certification && this.localFilters.certification !== 'toutes')
      );
    },
    periodeDisplay() {
      const periode = this.localPeriode || {};
      const type = periode.type || '';
      if (!type) {
        return 'Non défini';
      }

      if (type === 'hebdo') {
        const dateReference = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const { start, end, weekNumber } = this.getWeekRange(dateReference);
        const weekLabel = weekNumber ? `Semaine ${weekNumber}` : 'Semaine non définie';
        const formattedStart = this.formatDisplayDate(start);
        const formattedEnd = this.formatDisplayDate(end);
        if (formattedStart && formattedEnd) {
          return `${weekLabel} (${formattedStart} - ${formattedEnd})`;
        }
        return `${weekLabel}`;
      }

      if (type === 'journalier') {
        const referenceDate = periode.date_debut || this.getTodayISODate();
        const formattedDate = this.formatDisplayDate(referenceDate);
        if (formattedDate) {
          return `${formattedDate}`;
        }
        return 'Journalier';
      }

      if (type === 'custom') {
        const formattedStart = this.formatDisplayDate(periode.date_debut);
        const formattedEnd = this.formatDisplayDate(periode.date_fin);
        if (formattedStart && formattedEnd) {
          return `Personnalisé - ${formattedStart} - ${formattedEnd}`;
        }
        if (formattedStart || formattedEnd) {
          return `Personnalisé - ${formattedStart || formattedEnd}`;
        }
        return 'Personnalisé';
      }

      if (type === 'campagne') {
        const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
        const campLabel =
          this.$store.getters.camp_label ||
          this.$store.getters['camp_agricole/camp_label'] ||
          null;
        if (campId) {
          return campLabel ? `${campLabel} (ID ${campId})` : `Campagne en cours (ID ${campId})`;
        }
        return 'Campagne';
      }

      return type;
    },
    activeFiltersSummary() {
      const parts = [];
      if (this.localPeriode.type && this.localPeriode.type !== 'campagne') {
        parts.push(`Période: ${this.periodeDisplay}`);
      }
      if (this.selectedRegionId) {
        const region = this.regionOptions.find(r => r.id === this.selectedRegionId);
        if (region) {
          parts.push(`Région: ${region.nom}`);
        }
      }
      if (this.selectedZoneId) {
        const zone = this.zoneOptions.find(z => z.id === this.selectedZoneId);
        if (zone) {
          parts.push(`Zone: ${zone.nom}`);
        }
      }
      if (this.selectedCommuneId) {
        const commune = this.communeOptions.find(c => c.id === this.selectedCommuneId);
        if (commune) {
          parts.push(`Commune: ${commune.nom}`);
        }
      }
      if (this.selectedVillageId) {
        const village = this.villageOptions.find(v => v.id === this.selectedVillageId);
        if (village) {
          parts.push(`Village: ${village.nom}`);
        }
      }
      if (this.localFilters.ciId) {
        const ci = this.ciOptions.find(c => c.id === this.localFilters.ciId);
        if (ci) {
          parts.push(`CI: ${this.formatNiveauLabel(ci)}`);
        }
      }
      if (this.localFilters.antenneId) {
        const antenne = this.antenneOptions.find(a => a.id === this.localFilters.antenneId);
        if (antenne) {
          parts.push(`Antenne: ${this.formatNiveauLabel(antenne)}`);
        }
      }
      if (this.localFilters.groupementId) {
        const groupement = this.groupementOptions.find(g => g.id === this.localFilters.groupementId);
        if (groupement) {
          parts.push(`Groupement: ${this.formatNiveauLabel(groupement)}`);
        }
      }
      if (this.localFilters.regionId) {
        const region = this.regionOptions.find(r => r.id === this.localFilters.regionId);
        if (region) {
          parts.push(`Région: ${region.nom}`);
        }
      }
      if (this.localFilters.producteurId) {
        const producteur = this.producteurOptions.find(p => p.id === this.localFilters.producteurId);
        if (producteur) {
          parts.push(`Producteur: ${this.formatProducteurLabel(producteur)}`);
        }
      }
      if (this.localFilters.cultures && this.localFilters.cultures.length > 0) {
        const cultureNames = this.localFilters.cultures
          .map(id => {
            const culture = this.cultureOptions.find(c => c.id === id);
            return culture ? culture.nom : id;
          })
          .join(', ');
        parts.push(`Cultures: ${cultureNames}`);
      }
      if (this.localFilters.certification && this.localFilters.certification !== 'toutes') {
        const certif = this.certificationOptions.find(c => c.value === this.localFilters.certification);
        if (certif) {
          parts.push(`Certification: ${certif.label}`);
        }
      }
      return parts.length > 0 ? `Filtres actifs: ${parts.join(' | ')}` : 'Aucun filtre sélectionné';
    },
    currentCiLabel() {
      if (!this.localFilters.ciId) {
        return '';
      }
      const ci = this.ciOptions.find(c => c.id === this.localFilters.ciId);
      return ci ? this.formatNiveauLabel(ci) : '';
    },
    currentAntenneLabel() {
      if (!this.localFilters.antenneId) {
        return '';
      }
      const antenne = this.antenneOptions.find(a => a.id === this.localFilters.antenneId);
      return antenne ? this.formatNiveauLabel(antenne) : '';
    },
    currentGroupementLabel() {
      if (!this.localFilters.groupementId) {
        return '';
      }
      const groupement = this.groupementOptions.find(g => g.id === this.localFilters.groupementId);
      return groupement ? this.formatNiveauLabel(groupement) : '';
    },
    currentRegionLabel() {
      if (!this.selectedRegionId) {
        return '';
      }
      const region = this.regionOptions.find(r => r.id === this.selectedRegionId);
      return region ? region.nom : '';
    },
    currentZoneLabel() {
      if (!this.selectedZoneId) {
        return '';
      }
      const zone = this.zoneOptions.find(z => z.id === this.selectedZoneId);
      return zone ? zone.nom : '';
    },
    currentCommuneLabel() {
      if (!this.selectedCommuneId) {
        return '';
      }
      const commune = this.communeOptions.find(c => c.id === this.selectedCommuneId);
      return commune ? commune.nom : '';
    },
    currentVillageLabel() {
      if (!this.selectedVillageId) {
        return '';
      }
      const village = this.villageOptions.find(v => v.id === this.selectedVillageId);
      return village ? village.nom : '';
    },
    currentProducteurLabel() {
      if (!this.localFilters.producteurId) {
        return '';
      }
      const producteur = this.producteurOptions.find(p => p.id === this.localFilters.producteurId);
      return producteur ? this.formatProducteurLabel(producteur) : '';
    },
    currentCulturesLabel() {
      if (!this.localFilters.cultures || this.localFilters.cultures.length === 0) {
        return '';
      }
      const cultureNames = this.localFilters.cultures
        .map(id => {
          const culture = this.cultureOptions.find(c => c.id === id);
          return culture ? culture.nom : id;
        })
        .join(', ');
      return cultureNames.length > 30 ? `${cultureNames.substring(0, 30)}...` : cultureNames;
    },
    currentCertificationLabel() {
      if (!this.localFilters.certification || this.localFilters.certification === 'toutes') {
        return '';
      }
      const certif = this.certificationOptions.find(c => c.value === this.localFilters.certification);
      return certif ? certif.label : '';
    },
    filterSummaryText() {
      const parts = [];
      let niveauPrincipal = '';
      let niveauDetails = '';
      const campId = this.$store.getters.camp_id;
      const campLabel =
        this.$store.getters.camp_label ||
        this.$store.getters['camp_agricole/camp_label'] ||
        null;

      // Construire la chaîne de localités sélectionnées
      const localites = [];
      if (this.currentRegionLabel) {
        localites.push(`Région: ${this.currentRegionLabel}`);
      }
      if (this.currentZoneLabel) {
        localites.push(`Zone: ${this.currentZoneLabel}`);
      }
      if (this.currentCommuneLabel) {
        localites.push(`Commune: ${this.currentCommuneLabel}`);
      }
      if (this.currentVillageLabel) {
        localites.push(`Village: ${this.currentVillageLabel}`);
      }
      const localitesText = localites.length > 0 ? localites.join(' → ') : '';

      // Déterminer le niveau principal (priorité au plus spécifique)
      if (this.currentVillageLabel) {
        niveauPrincipal = `Village: <strong>${this.currentVillageLabel}</strong>`;
        niveauDetails = `Les données affichées correspondent uniquement au village "${this.currentVillageLabel}".`;
        if (localitesText) {
          niveauDetails += ` (${localitesText})`;
        }
      } else if (this.currentCommuneLabel) {
        niveauPrincipal = `Commune: <strong>${this.currentCommuneLabel}</strong>`;
        niveauDetails = `Les données affichées correspondent uniquement à la commune "${this.currentCommuneLabel}".`;
        if (localitesText) {
          niveauDetails += ` (${localitesText})`;
        }
      } else if (this.currentZoneLabel) {
        niveauPrincipal = `Zone: <strong>${this.currentZoneLabel}</strong>`;
        niveauDetails = `Les données affichées correspondent uniquement à la zone "${this.currentZoneLabel}".`;
        if (localitesText) {
          niveauDetails += ` (${localitesText})`;
        }
      } else if (this.currentRegionLabel) {
        niveauPrincipal = `Région: <strong>${this.currentRegionLabel}</strong>`;
        niveauDetails = `Les données affichées correspondent uniquement à la région "${this.currentRegionLabel}".`;
        if (localitesText) {
          niveauDetails += ` (${localitesText})`;
        }
      } else if (this.currentProducteurLabel) {
        niveauPrincipal = `Producteur: <strong>${this.currentProducteurLabel}</strong>`;
        niveauDetails = `Les données affichées correspondent uniquement au producteur "${this.currentProducteurLabel}".`;
      } else if (this.currentGroupementLabel) {
        niveauPrincipal = `Groupement: <strong>${this.currentGroupementLabel}</strong>`;
        niveauDetails = `Les données affichées correspondent uniquement au groupement "${this.currentGroupementLabel}" et à ses producteurs.`;
      } else if (this.currentAntenneLabel) {
        niveauPrincipal = `Antenne: <strong>${this.currentAntenneLabel}</strong>`;
        if (this.currentCiLabel) {
          niveauPrincipal += ` (supervisé par CI: <strong>${this.currentCiLabel}</strong>)`;
        }
        niveauDetails = `Les données affichées correspondent uniquement à l'antenne "${this.currentAntenneLabel}" et à ses groupements, producteurs et parcelles.`;
      } else if (this.currentCiLabel) {
        niveauPrincipal = `Contrôleur Interne: <strong>${this.currentCiLabel}</strong>`;
        niveauDetails = `Les données affichées correspondent uniquement au CI "${this.currentCiLabel}" et à tous les groupements, producteurs et parcelles qu'il supervise.`;
      } else {
        niveauPrincipal = 'Tous les niveaux';
        niveauDetails = 'Les données affichées correspondent à tous les niveaux de l\'organisation.';
      }

      // Campagne en cours
      if (campId) {
        const labelText = campLabel ? `${campLabel} (ID ${campId})` : `ID ${campId}`;
        parts.push(`<div style="margin-bottom: 8px;">Campagne en cours : <strong>${labelText}</strong></div>`);
      }

      parts.push(`<div style="margin-bottom: 12px;"><strong>${niveauPrincipal}</strong></div>`);
      parts.push(`<div style="margin-bottom: 12px;">${niveauDetails}</div>`);

      // Ajouter les autres filtres (cultures, certification, période)
      const otherFilters = [];

      if (this.currentCulturesLabel) {
        otherFilters.push(`Cultures: ${this.currentCulturesLabel}`);
      }
      if (this.currentCertificationLabel) {
        otherFilters.push(`Certification: ${this.currentCertificationLabel}`);
      }
      if (this.localPeriode.type && this.localPeriode.type !== 'campagne') {
        otherFilters.push(`Période: ${this.periodeDisplay}`);
      }

      if (otherFilters.length > 0) {
        parts.push(`<div style="margin-bottom: 12px;">Filtres supplémentaires: ${otherFilters.join(' | ')}</div>`);
      }

      // Calcul détaillé avec les données réelles
      parts.push(`<div style="margin-top: 16px; padding-top: 16px; border-top: 1px solid #dcdfe6;">`);
      parts.push(`<div style="margin-bottom: 8px;"><strong>Calcul détaillé :</strong></div>`);

      // Si une période différente de "campagne" est sélectionnée,
      // on s'aligne STRICTEMENT sur les chiffres renvoyés par le backend.
      const useBackendOnly =
        this.localPeriode &&
        this.localPeriode.type &&
        this.localPeriode.type !== 'campagne';

      // Données réelles (backend = source de vérité)
      const totalGroupementsBackend = this.filteredKpis.totalGroupements || 0;
      const totalParcellesBackend = this.filteredKpis.totalParcelles || 0;

      // Valeurs utilisées dans le résumé
      const totalGroupements = totalGroupementsBackend;
      const totalGroupementsInscrits = this.displayTotalGroupementsInscrits || 0;
      const totalParcelles = useBackendOnly
        ? totalParcellesBackend
        : (this.displayTotalParcelles || totalParcellesBackend);
      const totalQuantiteKg = this.quantiteCollecteeKg;
      const totalQuantiteTonnes = this.quantiteCollecteeTonnes;
      // Comptages calculés côté frontend pour le CI sélectionné (si disponibles)
      // Dès qu'une période autre que "campagne" est appliquée, on NE se base plus sur les comptages locaux,
      // mais uniquement sur les KPIs retournés par le backend.

      if (this.currentCiLabel) {
        const ciId = this.localFilters.ciId || '';
        // Utiliser les données du backend (source de vérité)
        const ciGroups = this.filteredKpis.totalGroupements || 0;
        const ciParcelles = this.filteredKpis.totalParcelles || 0;
        const ciAntennes = this.filteredKpis.totalAntennes || 0;
        const ciQuantiteKg = (this.filteredKpis.totalQuantiteCollectee || 0) * 1000; // Convertir tonnes en kg
        const ciQuantiteTonnes = this.filteredKpis.totalQuantiteCollectee || 0;
        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        parts.push(`<strong>${this.currentCiLabel}</strong>${ciId ? ` (CI ID = ${ciId})` : ''} supervise <strong>${this.formatNumber(ciGroups)}</strong> groupement${ciGroups > 1 ? 's' : ''}.<br/>`);
        parts.push(`Ces groupement${ciGroups > 1 ? 's' : ''} ${ciGroups > 1 ? 'ont' : 'a'} <strong>${this.formatNumber(ciParcelles)}</strong> parcelle${ciParcelles > 1 ? 's' : ''} au total.<br/>`);
        parts.push(`Unités de production (antennes) : <strong>${this.formatNumber(ciAntennes)}</strong><br/>`);
        if (ciQuantiteKg > 0) {
          parts.push(`Ces parcelles ont produit <strong>${this.formatNumber(ciQuantiteKg)}</strong> kg de récoltes.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées : <strong>${this.formatNumber(ciParcelles)}</strong> parcelle${ciParcelles > 1 ? 's' : ''} (via groupement${ciGroups > 1 ? 's' : ''} de ${this.currentCiLabel})<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(ciQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion : ${this.formatNumber(ciQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(ciQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(ciQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond uniquement aux quantités collectées des parcelles liées aux groupements supervisés par ${this.currentCiLabel} pour la campagne sélectionnée.`);
        } else {
          parts.push(`Ces parcelles n'ont pas encore produit de récoltes ou les données ne sont pas disponibles.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées : <strong>${this.formatNumber(ciParcelles)}</strong> parcelle${ciParcelles > 1 ? 's' : ''} (via groupement${ciGroups > 1 ? 's' : ''} de ${this.currentCiLabel})<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(ciQuantiteTonnes)}</strong> t (aucune récolte enregistrée)`);
        }
        parts.push(`</div>`);
      } else if (this.currentAntenneLabel) {
        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        parts.push(`L'antenne <strong>"${this.currentAntenneLabel}"</strong> contient <strong>${this.formatNumber(totalGroupements)}</strong> groupement${totalGroupements > 1 ? 's' : ''} et <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}.<br/>`);
        if (totalQuantiteKg > 0) {
          parts.push(`Ces parcelles ont produit <strong>${this.formatNumber(totalQuantiteKg)}</strong> kg de récoltes.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées : <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(totalQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion : ${this.formatNumber(totalQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(totalQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(totalQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond uniquement aux quantités collectées des parcelles de l'antenne "${this.currentAntenneLabel}" pour la campagne sélectionnée.`);
        } else {
          parts.push(`Ces parcelles n'ont pas encore produit de récoltes ou les données ne sont pas disponibles.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées : <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>0 t</strong> (aucune récolte enregistrée)`);
        }
        parts.push(`</div>`);
      } else if (this.currentGroupementLabel) {
        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        parts.push(`Le groupement <strong>"${this.currentGroupementLabel}"</strong> contient <strong>${this.formatNumber(this.filteredKpis.totalProducteurs || 0)}</strong> producteur${(this.filteredKpis.totalProducteurs || 0) > 1 ? 's' : ''} et <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}.<br/>`);
        if (totalQuantiteKg > 0) {
          parts.push(`Ces parcelles ont produit <strong>${this.formatNumber(totalQuantiteKg)}</strong> kg de récoltes.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées : <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(totalQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion : ${this.formatNumber(totalQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(totalQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(totalQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond uniquement aux quantités collectées des parcelles du groupement "${this.currentGroupementLabel}" pour la campagne sélectionnée.`);
        } else {
          parts.push(`Ces parcelles n'ont pas encore produit de récoltes ou les données ne sont pas disponibles.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées : <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>0 t</strong> (aucune récolte enregistrée)`);
        }
        parts.push(`</div>`);
      } else if (this.currentProducteurLabel) {
        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        parts.push(`Le producteur <strong>"${this.currentProducteurLabel}"</strong> possède <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}.<br/>`);
        if (totalQuantiteKg > 0) {
          parts.push(`Ces parcelles ont produit <strong>${this.formatNumber(totalQuantiteKg)}</strong> kg de récoltes.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées : <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(totalQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion : ${this.formatNumber(totalQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(totalQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(totalQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond uniquement aux quantités collectées des parcelles du producteur "${this.currentProducteurLabel}" pour la campagne sélectionnée.`);
        } else {
          parts.push(`Ces parcelles n'ont pas encore produit de récoltes ou les données ne sont pas disponibles.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées : <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>0 t</strong> (aucune récolte enregistrée)`);
        }
        parts.push(`</div>`);
      } else if (this.currentVillageLabel) {
        // Calculer les comptages filtrés par village
        const villageParcelles = this.villageParcellesCount || 0;
        const villageId = this.selectedVillageId;

        // Calculer les producteurs uniques du village
        const producteursVillageIds = new Set();
        if (this.parcellesProducteurs && villageId != null) {
          const villageIdNum = Number(villageId);
          const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
          this.parcellesProducteurs.forEach(pp => {
            if (!pp || pp.parcelle_id == null) {
              return;
            }
            if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
              return;
            }
            if (pp.village_id != null && Number(pp.village_id) === villageIdNum) {
              if (pp.producteur_id != null) {
                producteursVillageIds.add(Number(pp.producteur_id));
              }
            }
          });
        }

        const totalProducteursVillage = producteursVillageIds.size;
        const localitesDisplay = [this.currentRegionLabel, this.currentZoneLabel, this.currentCommuneLabel, this.currentVillageLabel].filter(Boolean).join(' → ');

        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        parts.push(`Le village <strong>"${this.currentVillageLabel}"</strong>${localitesDisplay ? ` (${localitesDisplay})` : ''} contient <strong>${this.formatNumber(villageParcelles)}</strong> parcelle${villageParcelles > 1 ? 's' : ''} et <strong>${this.formatNumber(totalProducteursVillage)}</strong> producteur${totalProducteursVillage > 1 ? 's' : ''}.<br/>`);

        const periodeRange = this.getPeriodeDateRange();
        const villageQuantiteKg = this.calculerQuantiteCollecteeLocaleParcelles(this.villageParcellesIds, periodeRange);
        const villageQuantiteTonnes = villageQuantiteKg / 1000;

        if (villageQuantiteKg > 0) {
          parts.push(`Ces parcelles ont produit <strong>${this.formatNumber(villageQuantiteKg)}</strong> kg de récoltes.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées (village ${this.currentVillageLabel}) : <strong>${this.formatNumber(villageParcelles)}</strong> parcelle${villageParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(villageQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion : ${this.formatNumber(villageQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(villageQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(villageQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond uniquement aux quantités collectées des parcelles du village "${this.currentVillageLabel}" pour la campagne sélectionnée.`);
        } else {
          parts.push(`Ces parcelles n'ont pas encore produit de récoltes ou les données ne sont pas disponibles.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées (village ${this.currentVillageLabel}) : <strong>${this.formatNumber(villageParcelles)}</strong> parcelle${villageParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>0 t</strong> (aucune récolte enregistrée)`);
        }
        parts.push(`</div>`);
      } else if (this.currentCommuneLabel) {
        // Calculer les comptages filtrés par commune
        const communeParcelles = this.communeParcellesCount || 0;
        const communeId = this.selectedCommuneId;

        // Calculer les producteurs uniques de la commune
        const producteursCommuneIds = new Set();
        if (this.parcellesProducteurs && communeId != null) {
          const communeIdNum = Number(communeId);
          const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
          this.parcellesProducteurs.forEach(pp => {
            if (!pp || pp.parcelle_id == null) {
              return;
            }
            if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
              return;
            }
            if (pp.commune_id != null && Number(pp.commune_id) === communeIdNum) {
              if (pp.producteur_id != null) {
                producteursCommuneIds.add(Number(pp.producteur_id));
              }
            }
          });
        }

        const totalProducteursCommune = producteursCommuneIds.size;
        const localitesDisplay = [this.currentRegionLabel, this.currentZoneLabel, this.currentCommuneLabel].filter(Boolean).join(' → ');

        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        parts.push(`La commune <strong>"${this.currentCommuneLabel}"</strong>${localitesDisplay ? ` (${localitesDisplay})` : ''} contient <strong>${this.formatNumber(communeParcelles)}</strong> parcelle${communeParcelles > 1 ? 's' : ''} et <strong>${this.formatNumber(totalProducteursCommune)}</strong> producteur${totalProducteursCommune > 1 ? 's' : ''}.<br/>`);

        const periodeRange = this.getPeriodeDateRange();
        const communeQuantiteKg = this.calculerQuantiteCollecteeLocaleParcelles(this.communeParcellesIds, periodeRange);
        const communeQuantiteTonnes = communeQuantiteKg / 1000;

        if (communeQuantiteKg > 0) {
          parts.push(`Ces parcelles ont produit <strong>${this.formatNumber(communeQuantiteKg)}</strong> kg de récoltes.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées (commune ${this.currentCommuneLabel}) : <strong>${this.formatNumber(communeParcelles)}</strong> parcelle${communeParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(communeQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion : ${this.formatNumber(communeQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(communeQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(communeQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond uniquement aux quantités collectées des parcelles de la commune "${this.currentCommuneLabel}" pour la campagne sélectionnée.`);
        } else {
          parts.push(`Ces parcelles n'ont pas encore produit de récoltes ou les données ne sont pas disponibles.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées (commune ${this.currentCommuneLabel}) : <strong>${this.formatNumber(communeParcelles)}</strong> parcelle${communeParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>0 t</strong> (aucune récolte enregistrée)`);
        }
        parts.push(`</div>`);
      } else if (this.currentZoneLabel) {
        // Utiliser les données du backend (source de vérité)
        const zoneParcelles = this.filteredKpis.totalParcelles || 0;
        const zoneProducteurs = this.filteredKpis.totalProducteurs || 0;
        const localitesDisplay = [this.currentRegionLabel, this.currentZoneLabel].filter(Boolean).join(' → ');

        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        parts.push(`La zone <strong>"${this.currentZoneLabel}"</strong>${localitesDisplay ? ` (${localitesDisplay})` : ''} contient <strong>${this.formatNumber(zoneParcelles)}</strong> parcelle${zoneParcelles > 1 ? 's' : ''} et <strong>${this.formatNumber(zoneProducteurs)}</strong> producteur${zoneProducteurs > 1 ? 's' : ''}.<br/>`);

        // Utiliser les données du backend pour la quantité collectée
        const zoneQuantiteKg = (this.filteredKpis.totalQuantiteCollectee || 0) * 1000; // Convertir tonnes en kg
        const zoneQuantiteTonnes = this.filteredKpis.totalQuantiteCollectee || 0;

        if (zoneQuantiteKg > 0) {
          parts.push(`Ces parcelles ont produit <strong>${this.formatNumber(zoneQuantiteKg)}</strong> kg de récoltes.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées (zone ${this.currentZoneLabel}) : <strong>${this.formatNumber(zoneParcelles)}</strong> parcelle${zoneParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(zoneQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion : ${this.formatNumber(zoneQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(zoneQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(zoneQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond uniquement aux quantités collectées des parcelles de la zone "${this.currentZoneLabel}" pour la campagne sélectionnée.`);
        } else {
          parts.push(`Ces parcelles n'ont pas encore produit de récoltes ou les données ne sont pas disponibles.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées (zone ${this.currentZoneLabel}) : <strong>${this.formatNumber(zoneParcelles)}</strong> parcelle${zoneParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(zoneQuantiteTonnes)}</strong> t (aucune récolte enregistrée)`);
        }
        parts.push(`</div>`);
      } else if (this.currentRegionLabel) {
        // Calculer les comptages filtrés par région
        const regionParcelles = this.regionParcellesCount || 0;
        const regionId = this.selectedRegionId;

        // Calculer les producteurs uniques de la région
        const producteursRegionIds = new Set();
        if (this.parcellesProducteurs && regionId != null) {
          const regionIdNum = Number(regionId);
          const campId = this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
          const parcelleIdsRegion = new Set();

          this.parcellesProducteurs.forEach(pp => {
            if (!pp || pp.parcelle_id == null) {
              return;
            }
            if (campId && pp.cmp_id != null && Number(pp.cmp_id) !== Number(campId)) {
              return;
            }
            if (pp.region_id != null && Number(pp.region_id) === regionIdNum) {
              parcelleIdsRegion.add(Number(pp.parcelle_id));
              if (pp.producteur_id != null) {
                producteursRegionIds.add(Number(pp.producteur_id));
              }
            }
          });
        }

        // Calculer les groupements et antennes de la région via les producteurs
        const groupementsRegionIds = new Set();
        const antennesRegionIds = new Set();
        if (this.producteurs && this.producteurs.length > 0) {
          this.producteurs.forEach(prod => {
            if (producteursRegionIds.has(prod.id)) {
              if (prod.groupement_id != null) {
                groupementsRegionIds.add(prod.groupement_id);
              }
            }
          });
        }
        if (this.groupements && this.groupements.length > 0) {
          this.groupements.forEach(g => {
            if (groupementsRegionIds.has(g.id)) {
              if (g.unite_production_id != null) {
                antennesRegionIds.add(g.unite_production_id);
              }
            }
          });
        }

        // Utiliser les comptages filtrés par période (sauf si période est "campagne")
        const totalProducteursRegion = this.regionProducteursCount;
        const totalGroupementsRegion = this.regionGroupementsCount;
        const totalAntennesRegion = this.regionAntennesCount;

        // Déterminer si on filtre par created_at ou non
        const isPeriodeCampagne = !this.localPeriode || !this.localPeriode.type || this.localPeriode.type === 'campagne';
        const periodeText = isPeriodeCampagne ? '' : ` (créé${regionParcelles > 1 ? 's' : ''} ${this.periodeDisplay ? `le ${this.periodeDisplay}` : 'sur la période sélectionnée'})`;

        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        if (isPeriodeCampagne) {
          parts.push(`La région <strong>"${this.currentRegionLabel}"</strong> contient <strong>${this.formatNumber(regionParcelles)}</strong> parcelle${regionParcelles > 1 ? 's' : ''}, <strong>${this.formatNumber(totalProducteursRegion)}</strong> producteur${totalProducteursRegion > 1 ? 's' : ''}, <strong>${this.formatNumber(totalGroupementsRegion)}</strong> groupement${totalGroupementsRegion > 1 ? 's' : ''} et <strong>${this.formatNumber(totalAntennesRegion)}</strong> antenne${totalAntennesRegion > 1 ? 's' : ''}.<br/>`);
        } else {
          parts.push(`Nombre de parcelles créées${periodeText} : <strong>${this.formatNumber(regionParcelles)}</strong> parcelle${regionParcelles > 1 ? 's' : ''}.<br/>`);
          parts.push(`Nombre de producteurs créés${periodeText} : <strong>${this.formatNumber(totalProducteursRegion)}</strong> producteur${totalProducteursRegion > 1 ? 's' : ''}.<br/>`);
          parts.push(`Nombre de groupements créés${periodeText} : <strong>${this.formatNumber(totalGroupementsRegion)}</strong> groupement${totalGroupementsRegion > 1 ? 's' : ''}.<br/>`);
          parts.push(`Nombre d'antennes créées${periodeText} : <strong>${this.formatNumber(totalAntennesRegion)}</strong> antenne${totalAntennesRegion > 1 ? 's' : ''}.<br/>`);
        }

        // Quantité collectée filtrée par région (campagne déjà filtrée côté backend, on restreint aux parcelles de la région)
        const periodeRange = this.getPeriodeDateRange();
        const regionQuantiteKg = this.calculerQuantiteCollecteeLocaleParcelles(this.regionParcellesIds, periodeRange);
        const regionQuantiteTonnes = regionQuantiteKg / 1000;

        if (regionQuantiteKg > 0) {
          parts.push(`Ces parcelles ont produit <strong>${this.formatNumber(regionQuantiteKg)}</strong> kg de récoltes.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées (région ${this.currentRegionLabel}) : <strong>${this.formatNumber(regionParcelles)}</strong> parcelle${regionParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>${this.formatNumber(regionQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion : ${this.formatNumber(regionQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(regionQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(regionQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond uniquement aux quantités collectées des parcelles de la région "${this.currentRegionLabel}" pour la campagne sélectionnée.`);
        } else {
          parts.push(`Ces parcelles n'ont pas encore produit de récoltes ou les données ne sont pas disponibles.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles filtrées (région ${this.currentRegionLabel}) : <strong>${this.formatNumber(regionParcelles)}</strong> parcelle${regionParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Quantité collectée : <strong>0 t</strong> (aucune récolte enregistrée)`);
        }
        parts.push(`</div>`);
      } else {
        parts.push(`<div style="margin-left: 16px; margin-bottom: 8px;">`);
        parts.push(`Total de <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''} dans le système.<br/>`);
        parts.push(`Total de <strong>${this.formatNumber(this.filteredKpis.totalProducteurs || 0)}</strong> producteur${(this.filteredKpis.totalProducteurs || 0) > 1 ? 's' : ''}.<br/>`);
        parts.push(`Total de <strong>${this.formatNumber(totalGroupementsInscrits)}</strong> groupement${totalGroupementsInscrits > 1 ? 's' : ''} (créé${totalGroupementsInscrits > 1 ? 's' : ''} sur la période sélectionnée).<br/>`);
        const totalAntennesInscrites = this.displayTotalAntennesInscrites || 0;
        parts.push(`Total de <strong>${this.formatNumber(totalAntennesInscrites)}</strong> antenne${totalAntennesInscrites > 1 ? 's' : ''} (créée${totalAntennesInscrites > 1 ? 's' : ''} sur la période sélectionnée).<br/>`);
        const totalAuditsInscrits = this.displayTotalAuditsInscrits || 0;
        parts.push(`Total de <strong>${this.formatNumber(totalAuditsInscrits)}</strong> audit${totalAuditsInscrits > 1 ? 's' : ''} (créé${totalAuditsInscrits > 1 ? 's' : ''} sur la période sélectionnée).<br/>`);
        const totalControlesInternesInscrits = this.displayTotalControlesInternesInscrits || 0;
        parts.push(`Total de <strong>${this.formatNumber(totalControlesInternesInscrits)}</strong> contrôle${totalControlesInternesInscrits > 1 ? 's' : ''} interne${totalControlesInternesInscrits > 1 ? 's' : ''} (créé${totalControlesInternesInscrits > 1 ? 's' : ''} sur la période sélectionnée).<br/>`);
        const totalControlesInternesTermines = this.displayTotalControlesInternesTermines || 0;
        parts.push(`Total de <strong>${this.formatNumber(totalControlesInternesTermines)}</strong> contrôle${totalControlesInternesTermines > 1 ? 's' : ''} interne${totalControlesInternesTermines > 1 ? 's' : ''} terminé${totalControlesInternesTermines > 1 ? 's' : ''}.<br/>`);
        if (totalQuantiteKg > 0) {
          parts.push(`Toutes les parcelles ont produit <strong>${this.formatNumber(totalQuantiteKg)}</strong> kg de récoltes au total.<br/><br/>`);
          parts.push(`<strong>Calcul :</strong><br/>`);
          parts.push(`• Parcelles : <strong>${this.formatNumber(totalParcelles)}</strong> parcelle${totalParcelles > 1 ? 's' : ''}<br/>`);
          parts.push(`• Somme Kilogrammes : <strong>${this.formatNumber(totalQuantiteKg)}</strong> kg<br/>`);
          parts.push(`• Conversion en tonnes : ${this.formatNumber(totalQuantiteKg)} ÷ 1000 = <strong>${this.formatNumber(totalQuantiteTonnes)}</strong> t<br/>`);
          parts.push(`• Affichage : "<strong>${this.formatNumber(totalQuantiteTonnes)} t</strong>"<br/><br/>`);
          parts.push(`<strong>Résultat :</strong> Le total affiché correspond à la quantité totale collectée pour la campagne sélectionnée.`);
        } else {
          parts.push(`Aucune récolte n'a encore été enregistrée ou les données ne sont pas disponibles.`);
        }
        parts.push(`</div>`);
      }

      parts.push(`</div>`);

      return parts.join('');
    },
    // Computed properties pour la modale des parcelles
    filteredParcellesList() {
      if (!Array.isArray(this.parcellesList) || this.parcellesList.length === 0) {
        return [];
      }

      let filtered = this.parcellesList;

      // Filtrer par recherche textuelle (optionnel côté UI)
      if (this.parcelleSearchQuery) {
        const query = this.parcelleSearchQuery.toLowerCase();
        filtered = filtered.filter(p => {
          const code = (p.code || (p.parcelle && p.parcelle.code) || '').toLowerCase();
          const prod = p.nom_producteur || this.formatProducteurName(p.producteur || p.producteur_data) || '';
          const producteurName = String(prod).toLowerCase();
          return code.includes(query) || producteurName.includes(query);
        });
      }

      // Filtrer par géolocalisation (optionnel côté UI)
      if (this.parcelleGeolocFilter === 'geoloc') {
        filtered = filtered.filter(p => this.isParcelleGeolocated(p));
      } else if (this.parcelleGeolocFilter === 'non-geoloc') {
        filtered = filtered.filter(p => !this.isParcelleGeolocated(p));
      }

      // Pagination locale
      const start = (this.parcellePage - 1) * this.parcellePageSize;
      const end = start + this.parcellePageSize;
      return filtered.slice(start, end);
    },
    parcelleTotalPages() {
      if (!Array.isArray(this.parcellesList) || this.parcellesList.length === 0) {
        return 1;
      }

      let filtered = this.parcellesList;

      if (this.parcelleSearchQuery) {
        const query = this.parcelleSearchQuery.toLowerCase();
        filtered = filtered.filter(p => {
          const code = (p.code || (p.parcelle && p.parcelle.code) || '').toLowerCase();
          const prod = p.nom_producteur || this.formatProducteurName(p.producteur || p.producteur_data) || '';
          const producteurName = String(prod).toLowerCase();
          return code.includes(query) || producteurName.includes(query);
        });
      }

      if (this.parcelleGeolocFilter === 'geoloc') {
        filtered = filtered.filter(p => this.isParcelleGeolocated(p));
      } else if (this.parcelleGeolocFilter === 'non-geoloc') {
        filtered = filtered.filter(p => !this.isParcelleGeolocated(p));
      }

      return Math.ceil(filtered.length / this.parcellePageSize) || 1;
    },
  },
  watch: {
    'filterOptions.niveaux.ci.options'(newOptions) {
      // Watcher pour mettre à jour les options CI quand elles changent dans le store
      this.updateCiOptionsList();
    },
    filterOptions: {
      handler() {
        // Watcher profond pour détecter les changements dans filterOptions
        this.updateCiOptionsList();
      },
      deep: true,
      immediate: false,
    },
    'localFilters.ciId'(newCiId) {
      if (newCiId) {
        // Réinitialiser les filtres dépendants
        const validAntenneIds = this.getValidAntenneIdsForCI(newCiId);
        if (this.localFilters.antenneId && !validAntenneIds.includes(this.localFilters.antenneId)) {
          this.localFilters.antenneId = null;
        }
        const validGroupementIds = this.getValidGroupementIdsForCI(newCiId);
        if (this.localFilters.groupementId && !validGroupementIds.includes(this.localFilters.groupementId)) {
          this.localFilters.groupementId = null;
          this.localFilters.producteurId = null;
        }
      }
    },
    'localFilters.antenneId': {
      async handler(newAntenneId, oldAntenneId) {
        if (newAntenneId) {
          // Réinitialiser les filtres dépendants
          const validGroupementIds = this.groupementOptions.map(g => g.id);
          if (this.localFilters.groupementId && !validGroupementIds.includes(this.localFilters.groupementId)) {
            this.localFilters.groupementId = null;
            this.localFilters.producteurId = null;
          }
          // Recharger les producteurs de cette antenne
          if (newAntenneId !== oldAntenneId) {
            await this.loadProducteursOptions();
          }
        } else {
          // Si l'antenne est désélectionnée, réinitialiser les filtres dépendants
          this.localFilters.groupementId = null;
          this.localFilters.producteurId = null;
          // Si aucun groupement n'est sélectionné, réinitialiser les producteurs
          if (!this.localFilters.groupementId) {
            this.producteurOptionsLocal = [];
          }
        }
      },
      immediate: false,
    },
    'localFilters.groupementId': {
      async handler(newGroupementId, oldGroupementId) {
        // Quand un groupement est sélectionné, charger automatiquement les producteurs de ce groupement
        if (newGroupementId !== oldGroupementId) {
          if (newGroupementId) {
            // Charger les producteurs du groupement sélectionné
            await this.loadProducteursOptions();
            // Vérifier si le producteur sélectionné appartient au nouveau groupement
            if (this.localFilters.producteurId) {
              const validProducteurIds = this.producteurOptions.map(p => p.id);
              if (!validProducteurIds.includes(this.localFilters.producteurId)) {
                this.localFilters.producteurId = null;
              }
            }
          } else {
            // Si le groupement est désélectionné, réinitialiser les producteurs
            this.localFilters.producteurId = null;
            this.producteurOptionsLocal = [];
          }
        }
      },
      immediate: false,
    },
    kpis: {
      handler(newKpis) {
        if (newKpis && Object.keys(newKpis).length > 0) {
          this.filteredKpis = {
            totalParcelles: newKpis.totalParcelles || 0,
            totalParcellesGeolocalisees: newKpis.totalParcellesGeolocalisees || 0,
            totalProducteurs: newKpis.totalProducteurs || 0,
            totalControleurs: newKpis.totalControleurs || 0,
            totalGroupements: newKpis.totalGroupements || 0,
            totalAntennes: newKpis.totalAntennes || 0,
            totalAudits: newKpis.totalAudits || 0,
            totalControlesInternes: newKpis.totalControlesInternes || 0,
            totalFormations: newKpis.totalFormations || 0,
            surfaceCertifiee: newKpis.surfaceCertifiee || 0,
            surfaceDeclassee: newKpis.surfaceDeclassee || 0,
            totalQuantiteCollectee: newKpis.totalQuantiteCollectee || newKpis.quantiteCollecteeFilteredValue || 0,
          };
          // Activer l'affichage du texte de résumé quand les KPIs sont mis à jour
          if (this.suppressFilterSummaryText) {
            this.showFilterSummaryText = false;
            this.suppressFilterSummaryText = false;
          } else {
            this.showFilterSummaryText = true;
          }
        }
      },
      immediate: true,
      deep: true,
    },
    localFilters: {
      handler() {
        // Réinitialiser le texte de résumé à chaque changement de filtre
        this.showFilterSummaryText = false;
      },
      deep: true,
      immediate: false,
    },
    carteModalVisible(newVal) {
      if (newVal && this.coordonneesParcelle.length > 0) {
        this.$nextTick(() => {
          this.initMap();
        });
      }
    },
  },
  async created() {
    try {
      await this.loadFilterOptions();
      // Mettre à jour les options CI après le chargement
      this.updateCiOptionsList();
      // Charger les régions, zones, communes et villages
      await this.getRegionList();
      await this.getZoneList();
      await this.getCommuneList();
      await this.getVillageList();
      // Les listes de localités sont maintenant passées en props depuis index.vue
    } catch (error) {
      console.error('[KpiFilterPanel] Erreur lors du chargement des options:', error);
    }
    this.syncWithStore();
    // Écouter les événements pour recevoir les KPIs
    this.$root.$on('kpi-data-updated', this.handleKpiDataUpdate);
  },
  beforeDestroy() {
    this.$root.$off('kpi-data-updated', this.handleKpiDataUpdate);
  },
  methods: {
    ...mapActions('dashboard', ['loadFilterOptions', 'updateFilter', 'resetFilters', 'loadProducteurs']),

    formatAISummary(text) {
      // Supporte soit des retours ligne réels, soit des séquences "\\n" renvoyées dans le JSON
      return String(text || '').replace(/\\r?\\n/g, '\n');
    },

    // Méthodes pour l'assistant IA
    async processAIQuery() {
      if (!this.aiQuery.trim()) {
        return;
      }

      this.aiLoading = true;
      this.aiError = null;

      try {
        console.log('Début du traitement de la requête IA...');
        // Préparer les données disponibles pour le contexte IA
        const availableData = {
          zones: this.zoneOptions.map(z => ({ id: z.id, nom: z.nom })),
          antennes: this.antenneOptions.map(a => ({ id: a.id, nom: a.nom })),
          controleurs: this.ciOptions.slice(0, 50).map(c => ({ id: c.id, nom: c.nom, prenom: c.prenom })),
        };

        // Préparer les filtres actuels
        const currentFilters = {
          zone_id: this.localFilters.zoneId,
          antenne_id: this.localFilters.antenneId,
          ci_id: this.localFilters.ciId,
          groupement_id: this.localFilters.groupementId,
          producteur_id: this.localFilters.producteurId,
          date_debut: this.localPeriode.date_debut,
          date_fin: this.localPeriode.date_fin,
        };

        console.log('Données envoyées à l\'API:', {
          query: this.aiQuery,
          current_filters: currentFilters,
          available_data: availableData,
        });

        // Appel à l'API backend
        const response = await DashboardAPI.processAIQuery({
          query: this.aiQuery,
          current_filters: currentFilters,
          available_data: availableData,
        });

        if (response.data && response.data.filters) {
          // Mapper les filtres de l'IA vers les filtres locaux
          const aiFilters = response.data.filters;
          const mappedFilters = {};

          if (aiFilters.zone_id) {
            mappedFilters.zoneId = aiFilters.zone_id;
          }
          if (aiFilters.antenne_id) {
            mappedFilters.antenneId = aiFilters.antenne_id;
          }
          if (aiFilters.ci_id) {
            mappedFilters.ciId = aiFilters.ci_id;
          }
          if (aiFilters.groupement_id) {
            mappedFilters.groupementId = aiFilters.groupement_id;
          }
          if (aiFilters.producteur_id) {
            mappedFilters.producteurId = aiFilters.producteur_id;
          }
          if (aiFilters.date_debut) {
            this.localPeriode.date_debut = aiFilters.date_debut;
            this.localPeriode.type = 'custom';
          }
          if (aiFilters.date_fin) {
            this.localPeriode.date_fin = aiFilters.date_fin;
            this.localPeriode.type = 'custom';
          }

          // Appliquer les filtres
          this.applyAIFilters(mappedFilters);

          // Afficher un message de confirmation
          this.$message.success(response.data.message || 'Filtres appliqués avec succès');
        }

        // Afficher la réponse de l'IA si disponible
        if (response.data && response.data.ai_response) {
          this.filterSummaryText = this.formatAIResponse(response.data.message || response.data.ai_response);
          this.showFilterSummaryText = true;
        }

        // Réinitialiser le champ de recherche
        this.aiQuery = '';
      } catch (error) {
        console.error('Erreur lors du traitement de la requête IA:', {
          error: error,
          response: error.response,
          status: error.response?.status,
          data: error.response?.data,
          message: error.message,
        });
        this.aiError = error.response?.data?.message || error.message || 'Une erreur est survenue. Veuillez réessayer.';
      } finally {
        this.aiLoading = false;
      }
    },

    applyAIFilters(filters) {
      // Mettre à jour les filtres locaux
      this.localFilters = { ...this.localFilters, ...filters };

      // Déclencher la mise à jour des filtres
      this.$nextTick(() => {
        this.applyFilters();
      });
    },

    formatAIResponse(response) {
      // Formater la réponse de l'IA pour l'affichage
      return response.replace(/\n/g, '<br>');
    },
    formatNumber(value) {
      if (value === null || value === undefined) {
        return '0';
      }
      return Number(value).toLocaleString('fr-FR');
    },
    resetFilteredKpis() {
      // Réinitialiser tous les KPIs à 0
      this.filteredKpis = {
        totalParcelles: 0,
        totalParcellesGeolocalisees: 0,
        totalProducteurs: 0,
        totalControleurs: 0,
        totalGroupements: 0,
        totalAntennes: 0,
        totalAudits: 0,
        totalControlesInternes: 0,
        totalFormations: 0,
        surfaceCertifiee: 0,
        surfaceDeclassee: 0,
        totalQuantiteCollectee: 0,
      };
      // Cacher la section "Statistiques (KPIs) selon les filtres appliqués"
      this.hasAppliedFilters = false;
      // Masquer le résumé textuel
      this.showFilterSummaryText = false;
      this.suppressFilterSummaryText = true;
    },
    handleKpiDataUpdate(kpis) {
      if (kpis && Object.keys(kpis).length > 0) {
        // Si les données sont encapsulées dans une propriété 'data' (réponse API standard)
        const data = kpis.data || kpis;
        this.filteredKpis = {
          totalParcelles: data.nombre_parcelles || 0,
          totalParcellesGeolocalisees: data.nombre_parcelles_geo || 0,
          totalProducteurs: data.nombre_producteurs || 0,
          totalControleurs: data.nombre_controleurs || 0,
          totalGroupements: data.nombre_groupements_actifs || 0,
          totalAntennes: data.nombre_antennes || 0,
          totalAudits: data.nombre_audits || 0,
          totalControlesInternes: data.nombre_controles_internes || 0,
          totalFormations: data.nombre_formations || 0,
          surfaceCertifiee: data.surface_certifiee || 0,
          surfaceDeclassee: data.surface_declassee || 0,
          totalQuantiteCollectee: data.quantite_collectee || 0,
          liste_controleurs: data.liste_controleurs || [],
        };
      }
    },
    updateCiOptionsList() {
      // Méthode pour mettre à jour les options CI depuis le store ou la prop
      let options = this.filterOptions?.niveaux?.ci?.options || [];

      // Si les options sont vides et que la prop controleurs est disponible, l'utiliser comme fallback
      if (options.length === 0 && this.controleurs && this.controleurs.length > 0) {
        options = this.controleurs.map(ctrl => ({
          id: ctrl.id,
          nom: ctrl.nom || ctrl.name,
          prenom: ctrl.prenom,
          label: ctrl.nom || ctrl.name,
        }));
      }

      // Normaliser les options pour s'assurer qu'elles ont bien les propriétés nécessaires
      const normalizedOptions = options.map(opt => {
        // S'assurer que l'option a un id
        if (!opt.id && opt.id !== 0) {
          console.warn('[KpiFilterPanel] Option CI sans id:', opt);
          return null;
        }
        // S'assurer que l'option a un label formaté
        const label = this.formatNiveauLabel(opt);
        return {
          ...opt,
          id: Number(opt.id),
          label: label || `CI ${opt.id}`,
        };
      }).filter(Boolean); // Retirer les options null

      // Mettre à jour la liste locale de manière réactive
      this.ciOptionsList = normalizedOptions;
    },
    formatNiveauLabel(option) {
      if (!option) {
        return '';
      }
      // Priorité : nom_prenom > nom > prenom nom > label > id
      if (option.nom_prenom) {
        return option.nom_prenom;
      }
      if (option.nom && option.prenom) {
        return `${option.nom} ${option.prenom}`.trim();
      }
      if (option.nom) {
        return option.nom;
      }
      if (option.prenom) {
        return option.prenom;
      }
      if (option.label) {
        return option.label;
      }
      if (option.name) {
        return option.name;
      }
      return `CI ${option.id || 'N/A'}`;
    },
    handleCIDropdown(visible) {
      if (visible && this.ciOptions.length === 0) {
        // possibilité future: recharger, pour l'instant rien
      }
    },
    handleCIChange(value) {
      // Fermer immédiatement le dropdown avant d'appliquer les filtres
      if (this.$refs.ciSelect) {
        this.$refs.ciSelect.blur();
      }
      // Appliquer les filtres dans le prochain tick pour permettre au dropdown de se fermer
      this.$nextTick(() => {
        // handleFilterChange() appelle déjà resetFilteredKpis()
        this.handleFilterChange();
      });
    },
    formatProducteurLabel(producteur) {
      if (producteur.nom && producteur.prenom) {
        return `${producteur.nom} ${producteur.prenom}`;
      }
      if (producteur.nom) {
        return producteur.nom;
      }
      return `Producteur ${producteur.id}`;
    },
    getValidAntenneIdsForCI(ciId) {
      const groupements = this.filterOptions?.niveaux?.groupement?.options || [];
      const groupementsForCI = groupements.filter(grp => grp.controleur_id === ciId);
      const antenneIds = [...new Set(groupementsForCI.map(grp => grp.unite_production_id).filter(Boolean))];
      return antenneIds;
    },
    getValidGroupementIdsForCI(ciId) {
      const groupements = this.filterOptions?.niveaux?.groupement?.options || [];
      return groupements.filter(grp => grp.controleur_id === ciId).map(grp => grp.id);
    },
    async handleProducteurDropdown(visible) {
      if (visible) {
        await this.loadProducteursOptions();
      }
    },
    async loadProducteursOptions() {
      if (this.loadingProducteurs) {
        return;
      }
      this.loadingProducteurs = true;
      try {
        const params = {};
        if (this.localFilters.groupementId) {
          params.groupement_id = this.localFilters.groupementId;
        } else if (this.localFilters.antenneId) {
          params.antenne_id = this.localFilters.antenneId;
        }
        const producteurs = await this.loadProducteurs(params);
        this.producteurOptionsLocal = Array.isArray(producteurs) ? producteurs : [];
      } catch (error) {
        console.error('Erreur lors du chargement des producteurs:', error);
        this.$message.error('Erreur lors du chargement des producteurs');
        this.producteurOptionsLocal = [];
      } finally {
        this.loadingProducteurs = false;
      }
    },
    handleRegionChange(value) {
      // Fermer d'abord le dropdown, puis seulement écrire la valeur dans le champ (UI),
      // sans déclencher le traitement des filtres.
      if (this.$refs.regionSelect) {
        this.$refs.regionSelect.blur();
      }
      this.$nextTick(() => {
        // Normaliser la valeur : null, undefined, ou chaîne vide devient null
        const normalizedValue = (value === null || value === undefined || value === '') ? null : value;
        this.uiRegionId = normalizedValue;
        // Réinitialiser localFilters.regionId aussi pour que selectedRegionId retourne null
        this.localFilters.regionId = normalizedValue;
        // Réinitialiser les filtres incompatibles (Zone, Commune, Village, CI, Antennes, Groupements, Producteurs)
        // car ils peuvent appartenir à une autre région
        this.uiZoneId = null;
        this.uiCommuneId = null;
        this.uiVillageId = null;
        this.localFilters.ciId = null;
        this.localFilters.antenneId = null;
        this.localFilters.groupementId = null;
        this.localFilters.producteurId = null;
        // Réinitialiser les KPIs à 0 et cacher la section
        this.resetFilteredKpis();
      });
    },
    async handleZoneChange(value) {
      if (this.$refs.zoneSelect) {
        this.$refs.zoneSelect.blur();
      }
      this.$nextTick(() => {
        this.uiZoneId = value;
        // Réinitialiser les filtres incompatibles (Commune, Village, CI, Antennes, Groupements, Producteurs)
        if (value) {
          this.uiCommuneId = null;
          this.uiVillageId = null;
          this.localFilters.ciId = null;
          this.localFilters.antenneId = null;
          this.localFilters.groupementId = null;
          this.localFilters.producteurId = null;
        }
        // Réinitialiser les KPIs à 0 et cacher la section
        this.resetFilteredKpis();
      });
      // Requette au backend pour avoir la liste des CI de la zone
      const response = await DashboardAPI.getCIList(this.localFilters.zoneId);
      this.ciOptions = response.data;
      console.log('CI Options:', this.ciOptions);
    },
    handleCommuneChange(value) {
      if (this.$refs.communeSelect) {
        this.$refs.communeSelect.blur();
      }
      this.$nextTick(() => {
        this.uiCommuneId = value;
        // Réinitialiser les filtres incompatibles (Village, CI, Antennes, Groupements, Producteurs)
        if (value) {
          this.uiVillageId = null;
          this.localFilters.ciId = null;
          this.localFilters.antenneId = null;
          this.localFilters.groupementId = null;
          this.localFilters.producteurId = null;
        }
        // Réinitialiser les KPIs à 0 et cacher la section
        this.resetFilteredKpis();
      });
    },
    handleVillageChange(value) {
      if (this.$refs.villageSelect) {
        this.$refs.villageSelect.blur();
      }
      this.$nextTick(() => {
        this.uiVillageId = value;
        // Réinitialiser les filtres incompatibles (CI, Antennes, Groupements, Producteurs)
        if (value) {
          this.localFilters.ciId = null;
          this.localFilters.antenneId = null;
          this.localFilters.groupementId = null;
          this.localFilters.producteurId = null;
        }
        // Réinitialiser les KPIs à 0 et cacher la section
        this.resetFilteredKpis();
      });
    },
    handleFilterChange() {
      // Ne plus appliquer automatiquement les filtres sur changement de select.
      // On se contente de masquer le résumé, il sera recalculé après clic sur "Appliquer les filtres".
      // Réinitialiser les KPIs à 0 et cacher la section
      this.resetFilteredKpis();
    },
    syncWithStore() {
      // Synchroniser avec les filtres du store
      if (this.activeFilters) {
        // Synchroniser la période
        if (this.activeFilters.periode) {
          this.localPeriode = { ...this.activeFilters.periode };
        }

        const niveau = this.activeFilters.niveau || {};
        if (this.activeFilters.region_id) {
          this.localFilters.regionId = this.activeFilters.region_id;
        }
        if (niveau.ci_id) {
          this.localFilters.ciId = niveau.ci_id;
        }
        if (niveau.antenne_id) {
          this.localFilters.antenneId = niveau.antenne_id;
        }
        if (niveau.groupement_id) {
          this.localFilters.groupementId = niveau.groupement_id;
        }
        if (niveau.producteur_id) {
          this.localFilters.producteurId = niveau.producteur_id;
        }
        if (this.activeFilters.cultures) {
          this.localFilters.cultures = [...this.activeFilters.cultures];
        }
        if (this.activeFilters.certification) {
          this.localFilters.certification = this.activeFilters.certification;
        }
      }
    },
    async handlePeriodeChange() {
      const type = this.localPeriode.type;
      if (type !== 'custom') {
        this.localPeriode.date_debut = null;
        this.localPeriode.date_fin = null;
      }
      // Réinitialiser les KPIs à 0 et cacher la section
      this.resetFilteredKpis();
      // Ne plus appliquer automatiquement les filtres au changement de type de période.
      // L'utilisateur devra cliquer sur "Appliquer les filtres".
      // Pour "hebdo", on ne pré-remplit plus la date, l'utilisateur doit la sélectionner manuellement
    },
    async handleDateChange() {
      // Changement de date: on ne lance plus automatiquement applyFilters.
      // On invalide simplement le résumé courant.
      // Réinitialiser les KPIs à 0 et cacher la section
      this.resetFilteredKpis();
    },
    getTodayISODate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatDisplayDate(dateStr) {
      if (!dateStr) {
        return null;
      }
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          return null;
        }
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return null;
      }
    },
    getWeekRange(dateStr) {
      if (!dateStr) {
        const today = this.getTodayISODate();
        dateStr = today;
      }

      try {
        let date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          const today = this.getTodayISODate();
          dateStr = today;
          date = new Date(dateStr);
        }

        // Obtenir le lundi de la semaine (ISO week)
        const day = date.getDay();
        const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Ajuster pour lundi = 1
        const monday = new Date(date.setDate(diff));
        monday.setHours(0, 0, 0, 0);

        // Obtenir le dimanche de la semaine
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        sunday.setHours(23, 59, 59, 999);

        // Calculer le numéro de semaine ISO
        const startOfYear = new Date(monday.getFullYear(), 0, 1);
        const pastDaysOfYear = (monday - startOfYear) / 86400000;
        const weekNumber = Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);

        const formatDate = (d) => {
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        return {
          start: formatDate(monday),
          end: formatDate(sunday),
          weekNumber,
        };
      } catch (e) {
        const today = this.getTodayISODate();
        return {
          start: today,
          end: today,
          weekNumber: null,
        };
      }
    },

    getPeriodeDateRange() {
      const type = this.localPeriode?.type;
      if (!type || type === 'campagne') {
        return null;
      }

      if (type === 'journalier') {
        const isoDate = this.localPeriode.date_debut || this.localPeriode.date_fin || this.getTodayISODate();
        if (!isoDate) {
          return null;
        }
        return { start: isoDate, end: isoDate };
      }

      if (type === 'hebdo') {
        const referenceDate = this.localPeriode.date_debut || this.localPeriode.date_fin || this.getTodayISODate();
        const { start, end } = this.getWeekRange(referenceDate);
        return { start, end };
      }

      if (type === 'custom') {
        const start = this.localPeriode.date_debut;
        const end = this.localPeriode.date_fin;
        if (!start && !end) {
          return null;
        }
        return {
          start: start || end,
          end: end || start,
        };
      }

      return null;
    },

    filtrerSacsParPeriode(sacs, periodeRange) {
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return sacs;
      }

      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };

      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };

      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);

      return sacs.filter(sac => {
        const createdAt = sac && sac.created_at;
        if (!createdAt) {
          return false;
        }
        const sacDate = new Date(createdAt);
        if (isNaN(sacDate.getTime())) {
          return false;
        }
        if (startDate && sacDate < startDate) {
          return false;
        }
        if (endDate && sacDate > endDate) {
          return false;
        }
        return true;
      });
    },
    // Export des parcelles (Excel / PDF)
    // Ouvre la modale des contrôleurs
    showControleursModal() {
      // Vérifier si la propriété existe et est un tableau
      if (this.filteredKpis.liste_controleurs && Array.isArray(this.filteredKpis.liste_controleurs)) {
        // Créer une copie profonde des données
        const controleurs = JSON.parse(JSON.stringify(this.filteredKpis.liste_controleurs));

        // Formater les données pour le tableau
        const controleursFormates = controleurs.map(controleur => ({
          id: controleur.id,
          code: controleur.code || 'N/A',
          nom: controleur.nom || 'N/A',
          prenom: controleur.prenom || 'N/A',
          email: controleur.email || 'N/A',
          numero: controleur.numero || 'N/A',
        }));

        // Mettre à jour les données réactives
        this.$set(this.filteredKpis, 'liste_controleurs', [...controleursFormates]);
      } else {
        this.$set(this.filteredKpis, 'liste_controleurs', []);
      }

      // Forcer la mise à jour du composant avant d'ouvrir la modale
      this.$nextTick(() => {
        this.controleursModalVisible = true;
      });
    },

    handleExportParcelles(format) {
      if (!format) {
        return;
      }
      try {
        let data = Array.isArray(this.parcellesList) ? [...this.parcellesList] : [];
        // Appliquer les mêmes filtres locaux que l'affichage (hors pagination)
        if (this.parcelleSearchQuery) {
          const q = this.parcelleSearchQuery.toLowerCase();
          data = data.filter(p => {
            const code = (p.code || (p.parcelle && p.parcelle.code) || '').toLowerCase();
            const prod = p.nom_producteur || (p.producteur || p.producteur_data ? this.formatProducteurName(p.producteur || p.producteur_data) : '');
            const producteurName = String(prod || '').toLowerCase();
            return code.includes(q) || producteurName.includes(q);
          });
        }
        if (this.parcelleGeolocFilter === 'geoloc') {
          data = data.filter(p => this.isParcelleGeolocated(p));
        } else if (this.parcelleGeolocFilter === 'non-geoloc') {
          data = data.filter(p => !this.isParcelleGeolocated(p));
        }

        if (format === 'excel') {
          this.exportParcellesToExcel(data);
        } else if (format === 'pdf') {
          this.exportParcellesToPDF(data);
        }
      } catch (e) {
        console.error('Erreur export parcelles:', e);
        this.$message.error("Erreur lors de l'export");
      } finally {
        this.$nextTick(() => {
          this.parcelleExportFormat = null;
        });
      }
    },

    exportParcellesToExcel(data) {
      try {
        const header = ['Code', 'Producteur', 'Groupement', 'Superficie (ha)', 'Statut', 'Certification', 'Cultures'];
        const exportData = (data || []).map(p => {
          const code = p.code || (p.parcelle && p.parcelle.code) || '';
          const producteur = p.nom_producteur || (p.producteur || p.producteur_data ? this.formatProducteurName(p.producteur || p.producteur_data) : '') || '';
          const groupement = p.groupement || p.groupement_nom || '';
          const superficie = p.superficie || (p.parcelle && p.parcelle.superficie) || '';
          const statut = this.getParcelleStatut ? (this.getParcelleStatut(p) || '') : (p.statut || (p.parcelle && p.parcelle.statut) || '');
          const certification = statut === 'AB' ? 'Bio' : (statut ? 'Non-bio' : '');
          const cultures = this.formatCultures ? (this.formatCultures(p.produits || p.cultures) || '') : (Array.isArray(p.cultures) ? p.cultures.join(', ') : (p.cultures || ''));
          return [code, producteur, groupement, superficie, statut, certification, cultures];
        });

        const filename = `parcelles_${new Date().toISOString().split('T')[0]}`;
        export_json_to_excel({ header, data: exportData, filename });
        this.$message.success('Export Excel généré');
      } catch (error) {
        console.error('Erreur export Excel:', error);
        this.$message.error("Erreur lors de l'export Excel");
      }
    },

    exportParcellesToPDF(data) {
      try {
        let doc;
        try {
          // eslint-disable-next-line new-cap
          doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
        } catch (e) {
          // eslint-disable-next-line new-cap
          doc = new jsPDF('landscape', 'mm', 'a4');
        }
        const marginLeft = 10;
        let y = 10;
        doc.setFontSize(14);
        doc.text('Export Parcelles', marginLeft, y);
        y += 8;
        doc.setFontSize(10);
        doc.text(`Date: ${new Date().toLocaleString()}`, marginLeft, y);
        y += 6;

        const header = ['Code', 'Producteur', 'Groupement', 'Superficie (ha)', 'Statut', 'Certif.', 'Cultures'];
        const lineHeight = 6;
        const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();

        doc.setFont(undefined, 'bold');
        doc.text(header.join(' | '), marginLeft, y);
        doc.setFont(undefined, 'normal');
        y += lineHeight;

        (data || []).forEach(p => {
          const code = p.code || (p.parcelle && p.parcelle.code) || '';
          const producteur = p.nom_producteur || (p.producteur || p.producteur_data ? this.formatProducteurName(p.producteur || p.producteur_data) : '') || '';
          const groupement = p.groupement || p.groupement_nom || '';
          const superficie = p.superficie || (p.parcelle && p.parcelle.superficie) || '';
          const statut = this.getParcelleStatut ? (this.getParcelleStatut(p) || '') : (p.statut || (p.parcelle && p.parcelle.statut) || '');
          const certification = statut === 'AB' ? 'Bio' : (statut ? 'Non-bio' : '');
          const cultures = this.formatCultures ? (this.formatCultures(p.produits || p.cultures) || '') : (Array.isArray(p.cultures) ? p.cultures.join(', ') : (p.cultures || ''));

          const line = [code, producteur, groupement, superficie, statut, certification, cultures]
            .map(v => String(v).replace(/\s+/g, ' ').trim())
            .join(' | ')
            .slice(0, 180);

          if (y + lineHeight > pageHeight - 10) {
            doc.addPage();
            y = 10;
            doc.setFont(undefined, 'bold');
            doc.text(header.join(' | '), marginLeft, y);
            doc.setFont(undefined, 'normal');
            y += lineHeight;
          }
          doc.text(line, marginLeft, y);
          y += lineHeight;
        });

        doc.save(`parcelles_${new Date().toISOString().split('T')[0]}.pdf`);
        this.$message.success('Export PDF généré');
      } catch (error) {
        console.error('Erreur export PDF:', error);
        this.$message.error("Erreur lors de l'export PDF");
      }
    },
    async applyFilters() {
      this.isApplying = true;
      // Réinitialiser le flag de suppression pour permettre l'affichage du résumé après le retour du backend
      this.suppressFilterSummaryText = false;
      // Masquer le résumé pendant le chargement
      this.showFilterSummaryText = false;
      try {
        // Indiquer au parent que les filtres sont en cours d'application
        this.$root.$emit('kpi-filters-loading', {
          loading: true,
          message: 'Application des filtres...',
        });

        const aiQuery = (this.aiQuery || '').trim();
        const filters = aiQuery ? this.buildAiFilters(aiQuery) : this.buildStandardFilters();

        // Mettre à jour les filtres dans le store (pour les autres composants / graphiques)
        await this.$store.dispatch('dashboard/updateFilters', filters);

        // Appeler le backend pour calculer les KPIs (source de vérité)
        const response = await DashboardAPI.getKPIs(filters);
        const payload = response && response.data ? response.data : response;
        // Axios -> response.data = { success: true, data: {...kpis} }
        const kpis = payload && payload.data ? payload.data : (payload || {});

        // Si la requête IA a été utilisée et qu'un résumé IA est présent, l'afficher
        if (filters.ai_query && kpis.resume_ia) {
          this.aiSummary = kpis.resume_ia;
        } else {
          this.aiSummary = null;
        }

        // Liste des parcelles filtrées (retour backend)
        this.parcellesList = Array.isArray(kpis.liste_parcelles) ? kpis.liste_parcelles : [];

        // Liste des controleurs (retour backend)
        this.controleursList = Array.isArray(kpis.liste_controleurs) ? kpis.liste_controleurs : [];

        // Créer une copie profonde des contrôleurs
        const controleurs = Array.isArray(kpis.liste_controleurs)
          ? JSON.parse(JSON.stringify(kpis.liste_controleurs))
          : [];

        // Créer un nouvel objet pour forcer la réactivité
        const newKpis = {
          ...this.filteredKpis, // Conserver les propriétés existantes
          totalParcelles: kpis.nombre_parcelles || 0,
          totalParcellesGeolocalisees: kpis.nombre_parcelles_geo || 0,
          totalProducteurs: kpis.nombre_producteurs || 0,
          totalControleurs: kpis.nombre_controleurs || 0,
          totalGroupements: kpis.nombre_groupements_actifs || 0,
          totalAntennes: kpis.nombre_antennes || 0,
          totalAudits: kpis.nombre_audits || 0,
          totalControlesInternes: kpis.nombre_controles_internes || 0,
          totalFormations: kpis.nombre_formations || 0,
          surfaceCertifiee: kpis.surface_certifiee || 0,
          surfaceDeclassee: kpis.surface_declassee || 0,
          totalQuantiteCollectee: kpis.quantite_collectee || 0,
          liste_controleurs: controleurs,
        };

        console.log('Nouveaux KPIs avant assignation:', newKpis);
        this.filteredKpis = newKpis;
        console.log('KPIs après assignation:', this.filteredKpis);
        console.log('Type de liste_controleurs après assignation:', typeof this.filteredKpis.liste_controleurs);
        console.log('Est un tableau après assignation:', Array.isArray(this.filteredKpis.liste_controleurs));

        // Marquer que des filtres ont été effectivement appliqués (retour backend OK)
        this.hasAppliedFilters = true;

        // Propager les KPIs vers les autres composants (KpiPanel, index.vue)
        this.$root.$emit('kpi-data-updated', this.filteredKpis);

        // Afficher le résumé textuel uniquement après réception des KPIs du backend
        if (!this.suppressFilterSummaryText) {
          this.showFilterSummaryText = true;
        }

        this.$message.success('Filtres appliqués avec succès');
      } catch (error) {
        this.$message.error(
          'Erreur lors de l\'application des filtres (calcul des KPIs côté serveur)'
        );
        throw error;
      } finally {
        this.isApplying = false;
        this.$root.$emit('kpi-filters-loading', { loading: false });
      }
    },

    buildStandardFilters() {
      const filters = {
        ai_query: null,
        periode: { ...this.localPeriode },
        niveau: {
          type: 'total',
          id: null,
        },
        producteur_id: null,
        groupement_id: null,
        antenne_id: null,
        ci_id: null,
        region_id: this.selectedRegionId || null,
        zone_id: this.selectedZoneId || null,
        commune_id: this.selectedCommuneId || null,
        village_id: this.selectedVillageId || null,
        cultures: this.localFilters.cultures || [],
        certification: this.localFilters.certification || 'toutes',
      };

      if (this.localFilters.producteurId) {
        filters.niveau.type = 'producteur';
        filters.niveau.id = this.localFilters.producteurId;
        filters.niveau.producteur_id = this.localFilters.producteurId;
        filters.producteur_id = this.localFilters.producteurId;
      } else if (this.localFilters.groupementId) {
        filters.niveau.type = 'groupement';
        filters.niveau.id = this.localFilters.groupementId;
        filters.niveau.groupement_id = this.localFilters.groupementId;
        filters.groupement_id = this.localFilters.groupementId;
      } else if (this.localFilters.antenneId) {
        filters.niveau.type = 'antenne';
        filters.niveau.id = this.localFilters.antenneId;
        filters.niveau.antenne_id = this.localFilters.antenneId;
        filters.antenne_id = this.localFilters.antenneId;
      } else if (this.localFilters.ciId) {
        filters.niveau.type = 'ci';
        filters.niveau.id = this.localFilters.ciId;
        filters.niveau.ci_id = this.localFilters.ciId;
        filters.ci_id = this.localFilters.ciId;
      }

      const campId = this.getCurrentCampagneId();
      if (campId) {
        filters.campagne_id = campId;
      }

      return filters;
    },

    buildAiFilters(query) {
      const filters = {
        ai_query: query,
        periode: {
          type: 'campagne',
          date_debut: null,
          date_fin: null,
        },
        niveau: {
          type: 'total',
          id: null,
        },
      };

      const campId = this.getCurrentCampagneId();
      if (campId) {
        filters.campagne_id = campId;
      }

      return filters;
    },

    getCurrentCampagneId() {
      return this.$store.getters.camp_id || this.$store.getters['camp_agricole/camp_id'];
    },
    async resetFilters() {
      this.uiRegionId = null; // Réinitialiser la région UI
      this.localPeriode = {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      };
      this.localFilters = {
        regionId: null,
        ciId: null,
        antenneId: null,
        groupementId: null,
        producteurId: null,
        cultures: [],
        certification: 'toutes',
      };
      // Réinitialiser les KPIs à 0 et cacher la section
      this.resetFilteredKpis();
      // Réinitialiser la liste backend des parcelles (tableau modal)
      this.parcellesList = [];
      this.parcellePage = 1;
      // Pas besoin de les réinitialiser
      await this.$store.dispatch('dashboard/resetFilters');
      this.$root.$emit('kpi-filters-refresh', {});
      this.$message.success('Filtres réinitialisés');
    },
    async getRegionList() {
      try {
        const query = { page: 1, limit: 1000, keyword: '' };
        const { data } = await regionResource.sublist('?typeApi="all"', query);
        this.regions = data || [];
      } catch (error) {
        this.regions = [];
      }
    },
    async getZoneList() {
      try {
        const query = { page: 1, limit: 1000, keyword: '' };
        const { data } = await zoneResource.sublist('?typeApi="all"', query);
        this.zones = data || [];
      } catch (error) {
        this.zones = [];
      }
    },
    async getCommuneList() {
      try {
        const query = { page: 1, limit: 1000, keyword: '' };
        const { data } = await communeResource.sublist('?typeApi="all"', query);
        this.communes = data || [];
      } catch (error) {
        this.communes = [];
      }
    },
    async getVillageList() {
      try {
        const query = { page: 1, limit: 1000, keyword: '' };
        const { data } = await villageResource.sublist('?typeApi="all"', query);
        this.villages = data || [];
      } catch (error) {
        this.villages = [];
      }
    },

    // Calcul de tous les KPIs localement (sauf quantité collectée qui vient du backend)
    calculerKpisLocauxDepuisParcelles(parcellesFiltrees) {
      // Calculer les autres KPIs
      const totalParcelles = parcellesFiltrees.length;
      const totalParcellesGeolocalisees = parcellesFiltrees.filter(p =>
        p.latitude != null && p.longitude != null &&
        p.latitude !== 0 && p.longitude !== 0
      ).length;

      // Calculer les producteurs uniques
      const producteurIds = new Set();
      const producteurIdByParcelleId = {};

      if (this.parcellesProducteurs && this.parcellesProducteurs.length > 0) {
        this.parcellesProducteurs.forEach(pp => {
          if (pp.parcelle_id != null && pp.producteur_id != null) {
            producteurIdByParcelleId[pp.parcelle_id] = pp.producteur_id;
          }
        });
      }

      parcellesFiltrees.forEach(p => {
        const producteurId = producteurIdByParcelleId[p.id];
        if (producteurId != null) {
          producteurIds.add(producteurId);
        }
      });

      const totalProducteurs = producteurIds.size;

      // Calculer les groupements et antennes
      const groupementIds = new Set();
      const antenneIds = new Set();

      if (this.producteurs && this.producteurs.length > 0) {
        this.producteurs.forEach(prod => {
          if (producteurIds.has(prod.id)) {
            if (prod.groupement_id != null) {
              groupementIds.add(prod.groupement_id);
            }
          }
        });
      }

      if (this.groupements && this.groupements.length > 0) {
        this.groupements.forEach(g => {
          if (groupementIds.has(g.id)) {
            if (g.unite_production_id != null) {
              antenneIds.add(g.unite_production_id);
            }
          }
        });
      }

      const totalGroupements = groupementIds.size;
      const totalAntennes = antenneIds.size;

      // KPIs fixes (non calculables localement pour l'instant)
      const totalAudits = this.kpis.totalAudits || 0;
      const totalControlesInternes = this.kpis.totalControlesInternes || 0;

      const result = {
        totalParcelles,
        totalParcellesGeolocalisees,
        totalProducteurs,
        totalControleurs: 0, // Non utilisé dans l'affichage actuel
        totalGroupements,
        totalAntennes,
        totalAudits,
        totalControlesInternes,
        totalQuantiteCollectee: 0, // Sera mis à jour par la requête backend
      };

      return result;
    },

    // Calcul local de la quantité collectée pour éviter les requêtes backend
    calculerQuantiteCollecteeLocale() {
      // Pour la quantité collectée, on veut filtrer d'abord par la période
      // sur les sacs (created_at), puis restreindre aux parcelles correspondant
      // aux filtres de niveau (CI, antenne, groupement, producteur, campagne).
      // Donc on utilise une version des parcelles filtrées SANS filtre de période.
      const parcellesFiltrees = this.getParcellesFiltreesPourQuantite();
      const parcelleIdsFiltrees = new Set(parcellesFiltrees.map(p => Number(p.id || (p.parcelle && p.parcelle.id))));
      const periodeRange = this.getPeriodeDateRange();
      return this.calculerQuantiteCollecteeLocaleParcelles(parcelleIdsFiltrees, periodeRange);
    },

    // Helper pour calculer la quantité collectée à partir d'un Set d'IDs de parcelles
    // Nouvelle logique:
    // 1) Filtrer d'abord les enregistrements (sacs/recoltes) par période via created_at
    // 2) Restreindre ensuite aux parcelles filtrées (parcelleIdsFiltrees)
    calculerQuantiteCollecteeLocaleParcelles(parcelleIdsFiltrees, periodeRange = null) {
      const payload = (this.dataQuantiteCollectee && this.dataQuantiteCollectee.data_quantite_collectee)
        ? this.dataQuantiteCollectee
        : (this.dataQuantiteCollectee && this.dataQuantiteCollectee.data && this.dataQuantiteCollectee.data.data_quantite_collectee)
          ? this.dataQuantiteCollectee.data
          : null;
      if (!payload || !payload.data_quantite_collectee) {
        return 0;
      }

      const tousLesSacs = payload.data_quantite_collectee;

      // 1) Filtrer par période sur created_at (journalier, hebdo, custom, etc.)
      const sacsFiltresParPeriode = this.filtrerSacsParPeriode(tousLesSacs, periodeRange);

      // 2) Restreindre aux parcelles filtrées (niveau: CI, antenne, groupement, producteur, campagne en cours)
      const sacsFiltres = sacsFiltresParPeriode.filter((sac) => {
        const parcelleId = Number(sac.parcelle_id);
        return parcelleIdsFiltrees.has(parcelleId);
      });

      // Somme des poids (déjà en kilogrammes côté backend)
      const totalKg = sacsFiltres.reduce(
        (sum, sac) => sum + (parseFloat(sac.poids) || 0),
        0
      );

      return totalKg;
    },

    // Méthode helper pour obtenir les parcelles filtrées selon les critères locaux
    // (sans filtre de période) – utilisée pour le calcul de la quantité collectée
    getParcellesFiltreesPourQuantite() {
      if (!this.parcelles || this.parcelles.length === 0) {
        return [];
      }

      // Créer des index pour des recherches rapides
      const producteurIdByParcelleId = {};
      const parcelleIdsInCampagne = new Set();

      if (this.parcellesProducteurs && this.parcellesProducteurs.length > 0) {
        this.parcellesProducteurs.forEach(pp => {
          if (pp.parcelle_id != null && pp.producteur_id != null) {
            producteurIdByParcelleId[pp.parcelle_id] = pp.producteur_id;
            parcelleIdsInCampagne.add(Number(pp.parcelle_id));
          }
        });
      }

      // Filtrer d'abord les parcelles pour ne garder que celles de la campagne active
      let parcellesFiltrees = this.parcelles.filter(p => {
        const parcelleId = Number(p.id || (p.parcelle && p.parcelle.id));
        return parcelleIdsInCampagne.has(parcelleId);
      });

      // Index des producteurs
      const producteurById = {};
      if (this.producteurs && this.producteurs.length > 0) {
        this.producteurs.forEach(prod => {
          if (prod.id != null) {
            producteurById[prod.id] = prod;
          }
        });
      }

      // Index des groupements
      const groupementById = {};
      if (this.groupements && this.groupements.length > 0) {
        this.groupements.forEach(g => {
          if (g.id != null) {
            groupementById[g.id] = g;
          }
        });
      }

      // Filtrer par producteur_id
      if (this.localFilters.producteurId) {
        const producteurIdNum = Number(this.localFilters.producteurId);
        parcellesFiltrees = parcellesFiltrees.filter(p => {
          const producteurId = producteurIdByParcelleId[p.id];
          return producteurId != null && Number(producteurId) === producteurIdNum;
        });
      }

      // Filtrer par groupement_id
      if (this.localFilters.groupementId) {
        const groupementIdNum = Number(this.localFilters.groupementId);
        parcellesFiltrees = parcellesFiltrees.filter(p => {
          const producteurId = producteurIdByParcelleId[p.id];
          if (producteurId != null) {
            const producteur = producteurById[producteurId];
            return producteur && Number(producteur.groupement_id) === groupementIdNum;
          }
          return false;
        });
      }

      // Filtrer par antenne_id (unite_production_id) via les groupements
      if (this.localFilters.antenneId) {
        const antenneIdNum = Number(this.localFilters.antenneId);
        const groupementIds = new Set();
        if (this.groupements && this.groupements.length > 0) {
          this.groupements.forEach(g => {
            if (g.unite_production_id != null && Number(g.unite_production_id) === antenneIdNum) {
              groupementIds.add(Number(g.id));
            }
          });
        }
        parcellesFiltrees = parcellesFiltrees.filter(p => {
          const producteurId = producteurIdByParcelleId[p.id];
          if (producteurId != null) {
            const producteur = producteurById[producteurId];
            return producteur && producteur.groupement_id != null && groupementIds.has(Number(producteur.groupement_id));
          }
          return false;
        });
      }

      // Filtrer par controleur_id (ci_id) via les groupements
      if (this.localFilters.ciId) {
        const ciIdNum = Number(this.localFilters.ciId);
        const groupementIds = new Set();
        if (this.groupements && this.groupements.length > 0) {
          this.groupements.forEach(g => {
            if (g.controleur_id != null && Number(g.controleur_id) === ciIdNum) {
              groupementIds.add(Number(g.id));
            }
          });
        }
        parcellesFiltrees = parcellesFiltrees.filter(p => {
          const producteurId = producteurIdByParcelleId[p.id];
          if (producteurId != null) {
            const producteur = producteurById[producteurId];
            return producteur && producteur.groupement_id != null && groupementIds.has(Number(producteur.groupement_id));
          }
          return false;
        });
      }

      // Filtrer par village_id (priorité au plus spécifique)
      const villageIdToFilter = this.selectedVillageId;
      if (villageIdToFilter) {
        const villageIdNum = Number(villageIdToFilter);
        const parcelleIdsByVillage = new Set();
        if (Array.isArray(this.parcellesProducteurs) && this.parcellesProducteurs.length > 0) {
          this.parcellesProducteurs.forEach(pp => {
            if (pp && pp.parcelle_id != null && pp.village_id != null && Number(pp.village_id) === villageIdNum) {
              parcelleIdsByVillage.add(Number(pp.parcelle_id));
            }
          });
        }
        parcellesFiltrees = parcellesFiltrees.filter(p => parcelleIdsByVillage.has(Number(p.id || (p.parcelle && p.parcelle.id))));
      } else if (this.selectedCommuneId) {
        // Filtrer par commune_id
        const communeIdNum = Number(this.selectedCommuneId);
        const parcelleIdsByCommune = new Set();
        if (Array.isArray(this.parcellesProducteurs) && this.parcellesProducteurs.length > 0) {
          this.parcellesProducteurs.forEach(pp => {
            if (pp && pp.parcelle_id != null && pp.commune_id != null && Number(pp.commune_id) === communeIdNum) {
              parcelleIdsByCommune.add(Number(pp.parcelle_id));
            }
          });
        }
        parcellesFiltrees = parcellesFiltrees.filter(p => parcelleIdsByCommune.has(Number(p.id || (p.parcelle && p.parcelle.id))));
      } else if (this.selectedZoneId) {
        // Filtrer par zone_id
        const zoneIdNum = Number(this.selectedZoneId);
        const parcelleIdsByZone = new Set();
        if (Array.isArray(this.parcellesProducteurs) && this.parcellesProducteurs.length > 0) {
          this.parcellesProducteurs.forEach(pp => {
            if (pp && pp.parcelle_id != null && pp.zone_id != null && Number(pp.zone_id) === zoneIdNum) {
              parcelleIdsByZone.add(Number(pp.parcelle_id));
            }
          });
        }
        parcellesFiltrees = parcellesFiltrees.filter(p => parcelleIdsByZone.has(Number(p.id || (p.parcelle && p.parcelle.id))));
      } else {
        // Filtrer par region_id (utiliser selectedRegionId qui priorise uiRegionId)
        const regionIdToFilter = this.selectedRegionId || this.localFilters.regionId;
        if (regionIdToFilter) {
          const regionIdNum = Number(regionIdToFilter);
          // Optimisation: construire une fois l'ensemble des parcelles appartenant à la région
          // à partir de parcellesProducteurs (pp.region_id), puis filtrer par appartenance.
          const parcelleIdsByRegion = new Set();
          if (Array.isArray(this.parcellesProducteurs) && this.parcellesProducteurs.length > 0) {
            this.parcellesProducteurs.forEach(pp => {
              if (pp && pp.parcelle_id != null && pp.region_id != null && Number(pp.region_id) === regionIdNum) {
                parcelleIdsByRegion.add(Number(pp.parcelle_id));
              }
            });
          }
          parcellesFiltrees = parcellesFiltrees.filter(p => parcelleIdsByRegion.has(Number(p.id || (p.parcelle && p.parcelle.id))));
        }
      }
      return parcellesFiltrees;
    },

    // Méthode helper pour obtenir les parcelles filtrées selon les critères locaux
    // y compris le filtre de période appliqué sur parcelle_producteur.created_at
    getParcellesFiltrees() {
      const parcellesSansPeriode = this.getParcellesFiltreesPourQuantite();

      // Appliquer ensuite le filtre de période sur les parcelles (par parcelle_producteur.created_at)
      const periodeRange = this.getPeriodeDateRange();
      if (!periodeRange || (!periodeRange.start && !periodeRange.end)) {
        return parcellesSansPeriode;
      }

      // Créer un index de parcelle_producteur.created_at par parcelle_id
      const createdAtByParcelleId = {};
      if (Array.isArray(this.parcellesProducteurs) && this.parcellesProducteurs.length > 0) {
        this.parcellesProducteurs.forEach(pp => {
          if (pp && pp.parcelle_id != null && pp.created_at) {
            createdAtByParcelleId[Number(pp.parcelle_id)] = pp.created_at;
          }
        });
      }

      const normalizeStart = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(0, 0, 0, 0);
        return date;
      };

      const normalizeEnd = (value) => {
        if (!value) {
          return null;
        }
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) {
          return null;
        }
        date.setHours(23, 59, 59, 999);
        return date;
      };

      const startDate = normalizeStart(periodeRange.start);
      const endDate = normalizeEnd(periodeRange.end);

      // Filtrer par created_at (parcelle_producteur.created_at): inclure les items créés exactement à la date
      // startDate est normalisé à 00:00:00.000, endDate à 23:59:59.999
      // Les comparaisons < et > excluent uniquement les items avant/après, incluant ceux créés exactement à la date
      return parcellesSansPeriode.filter((p) => {
        const parcelleId = Number(p.id || (p.parcelle && p.parcelle.id));
        // Utiliser parcelle_producteur.created_at au lieu de parcelles.created_at
        const createdAt = createdAtByParcelleId[parcelleId] || (p && p.created_at);
        if (!createdAt) {
          return false;
        }
        const parcelleDate = new Date(createdAt);
        if (Number.isNaN(parcelleDate.getTime())) {
          return false;
        }
        if (startDate && parcelleDate < startDate) {
          return false;
        }
        if (endDate && parcelleDate > endDate) {
          return false;
        }
        return true;
      });
    },
    openKpiModal(title, value) {
      // Ouvrir la modale directement dans KpiFilterPanel
      this.selectedKpiModalTitle = title;
      this.selectedKpiModalValue = value;

      if (title === 'Parcelles') {
        this.parcellePage = 1;
      }

      this.kpiModalVisible = true;
    },
    closeKpiModal() {
      this.kpiModalVisible = false;
      this.parcelleSearchQuery = '';
      this.parcelleGeolocFilter = 'tous';
      this.parcellePage = 1;
    },
    nextParcellePage() {
      if (this.parcellePage < this.parcelleTotalPages) {
        this.parcellePage += 1;
      }
    },
    prevParcellePage() {
      if (this.parcellePage > 1) {
        this.parcellePage -= 1;
      }
    },
    formatProducteurName(producteur) {
      if (!producteur) {
        return 'N/A';
      }
      if (typeof producteur === 'string') {
        return producteur;
      }
      const nom = producteur.nom || '';
      const prenom = producteur.prenom || '';
      return [nom, prenom].filter(Boolean).join(' ') || 'N/A';
    },
    formatLocalisation(parcelle) {
      // Gérer les différentes structures de données
      const parcelleData = parcelle.parcelle || parcelle;

      // Récupérer le champ GPS
      const gpsData = parcelleData.gps || parcelle.gps;

      if (!gpsData) {
        return 'N/A';
      }

      // Essayer de parser le GPS si c'est une chaîne JSON
      let gpsPoints = [];
      try {
        if (typeof gpsData === 'string') {
          // Essayer de parser comme JSON (y compris les chaînes double-encodées)
          let parsed = JSON.parse(gpsData);
          if (typeof parsed === 'string') {
            try {
              parsed = JSON.parse(parsed);
            } catch (e) {
              // garder la chaîne si second parse impossible
            }
          }
          gpsPoints = Array.isArray(parsed) ? parsed : [parsed];
        } else if (Array.isArray(gpsData)) {
          gpsPoints = gpsData;
        } else {
          gpsPoints = [gpsData];
        }
      } catch (e) {
        // Si le parsing échoue, traiter comme une chaîne simple
        // Peut-être un format personnalisé, on l'affiche tel quel
        return gpsData;
      }

      // Formater les points GPS
      const formattedPoints = gpsPoints.map((point) => {
        // Si c'est un tableau [lng, lat] ou [lat, lng]
        if (Array.isArray(point) && point.length >= 2) {
          // Détecter l'ordre: au Togo, latitude ~6-11°, longitude ~0-2°
          const val1 = parseFloat(point[0]);
          const val2 = parseFloat(point[1]);
          if (val1 > 5 && val1 < 12) {
            // C'est latitude en premier
            return `${val1}, ${val2}`;
          }
          // C'est longitude en premier
          return `${val2}, ${val1}`;
        }
        // Si c'est un objet avec longitude et latitude
        if (typeof point === 'object' && point !== null) {
          if (point.longitude !== undefined && point.latitude !== undefined) {
            return `${point.latitude}, ${point.longitude}`;
          }
        }
        // Si c'est une chaîne, l'afficher tel quel
        return String(point);
      }).filter(Boolean);

      return formattedPoints.length > 0 ? formattedPoints.join(' | ') : 'N/A';
    },
    getParcelleStatut(parcelle) {
      // Gérer les différentes structures de données
      return parcelle.statut || (parcelle.parcelle && parcelle.parcelle.statut) || null;
    },
    formatCultures(cultures) {
      if (!cultures) {
        return 'N/A';
      }
      if (Array.isArray(cultures)) {
        if (cultures.length === 0) {
          return 'N/A';
        }
        // Si ce sont des objets avec une propriété 'nom'
        if (cultures[0] && typeof cultures[0] === 'object' && cultures[0].nom) {
          return cultures.map(c => c.nom).join(', ');
        }
        // Si ce sont des strings
        return cultures.join(', ');
      }
      if (typeof cultures === 'string') {
        return cultures;
      }
      return 'N/A';
    },
    getStatutTagType(statut) {
      if (statut === 'AB') {
        return 'success';
      }
      if (statut === 'Conversion') {
        return 'warning';
      }
      return 'info';
    },
    isParcelleGeolocated(parcelle) {
      // Gérer les différentes structures de données
      const parcelleData = parcelle.parcelle || parcelle;

      // Récupérer le champ GPS
      const gpsData = parcelleData.gps || parcelle.gps;

      if (!gpsData) {
        return false;
      }

      // Vérifier si les données GPS sont valides (non vides)
      try {
        if (typeof gpsData === 'string') {
          // Essayer de parser comme JSON (y compris double-encodage)
          try {
            let parsed = JSON.parse(gpsData);
            if (typeof parsed === 'string') {
              try {
                parsed = JSON.parse(parsed);
              } catch (e) {
                // garder la chaîne si second parse impossible
              }
            }
            if (Array.isArray(parsed)) {
              return parsed.length > 0;
            }
            return parsed !== null && parsed !== undefined && String(parsed).trim() !== '';
          } catch (parseError) {
            // Si ce n'est pas du JSON, vérifier si la chaîne n'est pas vide
            return gpsData.trim() !== '';
          }
        } else if (Array.isArray(gpsData)) {
          return gpsData.length > 0;
        }
        return gpsData !== null && gpsData !== undefined;
      } catch (e) {
        // En cas d'erreur, considérer comme non géolocalisé
        return false;
      }
    },
    async voirCarteParcelle(parcelle) {
      // Ouvrir la modal avec la carte de la parcelle
      const parcelleId = parcelle.id || parcelle.parcelle_id || (parcelle.parcelle && parcelle.parcelle.id);

      if (!parcelleId) {
        this.$message.warning('ID de parcelle introuvable');
        return;
      }

      this.selectedParcelleForCarte = parcelle;
      this.carteModalKey += 1;
      this.coordonneesParcelle = [];
      this.loadingCoordonnees = true;

      // Charger les coordonnées de la parcelle
      await this.loadCoordonneesParcelle(parcelleId);

      // Ouvrir la modal
      this.$nextTick(() => {
        this.carteModalVisible = true;
      });
    },
    closeCarteModal() {
      this.carteModalVisible = false;
      if (this.mapInstance) {
        this.mapInstance.remove();
        this.mapInstance = null;
      }
    },
    async loadCoordonneesParcelle(parcelleId) {
      try {
        // Utiliser les coordonnées GPS de la parcelle si disponibles
        const parcelle = this.parcellesList.find(p => {
          const id = p.id || (p.parcelle && p.parcelle.id);
          return id && Number(id) === Number(parcelleId);
        });

        if (parcelle) {
          const parcelleData = parcelle.parcelle || parcelle;
          const gpsData = parcelleData.gps || parcelle.gps;

          if (gpsData) {
            let gpsPoints = [];
            try {
              if (typeof gpsData === 'string') {
                let parsed = JSON.parse(gpsData);
                if (typeof parsed === 'string') {
                  try {
                    parsed = JSON.parse(parsed);
                  } catch (e) {
                    // garder la chaîne si second parse impossible
                  }
                }
                gpsPoints = Array.isArray(parsed) ? parsed : [parsed];
              } else if (Array.isArray(gpsData)) {
                gpsPoints = gpsData;
              } else {
                gpsPoints = [gpsData];
              }

              // Transformer en format [longitude, latitude]
              this.coordonneesParcelle = gpsPoints.map((point) => {
                if (Array.isArray(point) && point.length >= 2) {
                  const val1 = parseFloat(point[0]);
                  const val2 = parseFloat(point[1]);
                  // Détecter l'ordre: au Togo, latitude ~6-11°, longitude ~0-2°
                  if (val1 > 5 && val1 < 12) {
                    // C'est latitude en premier
                    return [val2, val1];
                  }
                  // C'est longitude en premier
                  return [val1, val2];
                }
                if (typeof point === 'object' && point !== null) {
                  if (point.longitude !== undefined && point.latitude !== undefined) {
                    return [parseFloat(point.longitude), parseFloat(point.latitude)];
                  }
                }
                return null;
              }).filter(coord => coord !== null);
            } catch (e) {
              console.error('Erreur lors du parsing des coordonnées GPS:', e);
            }
          }
        }
      } catch (error) {
        console.error('Erreur lors du chargement des coordonnées:', error);
        this.$message.error('Erreur lors du chargement des coordonnées de la parcelle');
      } finally {
        this.loadingCoordonnees = false;
      }
    },
    initMap() {
      // Détruire la carte existante si elle existe
      if (this.mapInstance) {
        this.mapInstance.remove();
        this.mapInstance = null;
      }

      // Attendre que le conteneur soit disponible
      this.$nextTick(() => {
        const container = document.getElementById('carteParcelleContainer');
        if (!container) {
          console.error('Conteneur de carte introuvable');
          return;
        }

        mapboxgl.accessToken = this.mapboxAccessToken;

        const nav = new mapboxgl.NavigationControl();

        // Calculer le centre des coordonnées
        let center = [1.1868609, 6.2056304]; // Centre par défaut
        if (this.coordonneesParcelle.length > 0) {
          const lngs = this.coordonneesParcelle.map(c => c[0]);
          const lats = this.coordonneesParcelle.map(c => c[1]);
          center = [
            (Math.min(...lngs) + Math.max(...lngs)) / 2,
            (Math.min(...lats) + Math.max(...lats)) / 2,
          ];
        }

        const map = new mapboxgl.Map({
          container: 'carteParcelleContainer',
          style: 'mapbox://styles/mapbox/streets-v12',
          center: center,
          zoom: 15,
        });

        this.mapInstance = map;

        const geojson = {
          type: 'FeatureCollection',
          features: [
            {
              type: 'Feature',
              geometry: {
                type: 'LineString',
                properties: {},
                coordinates: this.coordonneesParcelle,
              },
            },
          ],
        };

        map.on('load', () => {
          map.addSource('LineString', {
            type: 'geojson',
            data: geojson,
          });

          map.addLayer({
            id: 'LineString',
            type: 'line',
            source: 'LineString',
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#ec1232',
              'line-width': 2,
            },
          });

          // Ajouter un polygone rempli
          if (this.coordonneesParcelle.length > 0) {
            // Fermer le polygone si nécessaire
            const closedCoords = [...this.coordonneesParcelle];
            if (closedCoords[0][0] !== closedCoords[closedCoords.length - 1][0] ||
                closedCoords[0][1] !== closedCoords[closedCoords.length - 1][1]) {
              closedCoords.push(closedCoords[0]);
            }

            map.addSource('Polygon', {
              type: 'geojson',
              data: {
                type: 'Feature',
                geometry: {
                  type: 'Polygon',
                  coordinates: [closedCoords],
                },
              },
            });

            map.addLayer({
              id: 'Polygon',
              type: 'fill',
              source: 'Polygon',
              paint: {
                'fill-color': '#ec1232',
                'fill-opacity': 0.3,
              },
            });
          }

          // Bouton zoom
          const zoomButton = document.getElementById('zoomto-parcelle');
          if (zoomButton) {
            zoomButton.addEventListener('click', () => {
              const coordinates = geojson.features[0].geometry.coordinates;
              const bounds = new mapboxgl.LngLatBounds(
                coordinates[0],
                coordinates[0]
              );

              for (const coord of coordinates) {
                bounds.extend(coord);
              }

              map.fitBounds(bounds, {
                padding: 20,
              });
            });
          }
        });

        map.addControl(nav, 'bottom-right');

        const geolocate = new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true,
          },
          trackUserLocation: true,
        });
        map.addControl(geolocate, 'bottom-right');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* Styles pour l'assistant IA */
.ai-assistant {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  margin-bottom: 20px;
}

.ai-assistant .el-input {
  margin-bottom: 8px;
}

.error-message {
  color: #f56c6c;
  margin-top: 8px;
  font-size: 12px;
}

.filter-summary-text {
  margin: 0 0 20px 0;
  padding: 16px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border-left: 4px solid #409eff;
  font-size: 14px;
  line-height: 1.6;
  color: #606266;
}

.kpi-filter-panel {
  padding: 16px;
}

.filter-form {
  ::v-deep .el-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-select {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .filter-form {
    ::v-deep .el-form-item__label {
      width: 100% !important;
      text-align: left;
      margin-bottom: 8px;
    }

    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}

.filters-result-section {
  margin-top: 20px;
}

.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }
}

.info-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  height: 108px;
  padding: 16px 45px;
  box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
  border-color: rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: box-shadow 0.3s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 4px 6px 50px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
}

.info-text {
  display: flex;
  flex-direction: column;
  font-weight: bold;

  .card-panel-num {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 4px;
    word-break: break-word;
    line-height: 1.4;
  }
}

.kpi-detail-modal {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
}

.kpi-modal-content {
  padding: 0;
}

.parcelles-table-container {
  width: 100%;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #909399;
}

.carte-modal-content {
  padding: 0;
}

.carte-fullscreen-container {
  position: relative;
  width: 100%;
  margin-top: 15px;
}

.carte-fullscreen-map {
  width: 100%;
  height: 500px;
  border-radius: 6px;
  overflow: hidden;
}

.btn-control-carte {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  padding: 8px 16px;
  background: #00ab53;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.btn-control-carte:hover {
  background: #009944;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.carte-info-floating {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
  padding: 12px 16px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-width: 300px;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.carte-info-floating p {
  margin: 6px 0;
  font-size: 13px;
  line-height: 1.4;
  color: #303133;
}

.carte-info-floating strong {
  color: #606266;
  font-weight: 600;
}

.loading-coordonnees,
.no-coordonnees {
  padding: 40px;
  text-align: center;
  color: #909399;
}

::v-deep .carte-parcelle-modal.fullscreen-modal {
  margin: 0 !important;
  height: 100vh;
}

::v-deep .carte-parcelle-modal.fullscreen-modal .el-dialog {
  margin: 0 !important;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

::v-deep .carte-parcelle-modal.fullscreen-modal .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 0;
}

::v-deep .carte-parcelle-modal.fullscreen-modal .el-dialog__header {
  padding: 20px;
}

::v-deep .carte-parcelle-modal.fullscreen-modal .el-dialog__footer {
  padding: 20px;
}
</style>

